var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFondo2(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1088,
    height: 724,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    overflow: "hidden",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 98,
    y: 2,
    width: 1088,
    height: 724
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: 913,
    y1: 147,
    x2: 913,
    y2: 527,
    gradientUnits: "userSpaceOnUse",
    spreadMethod: "reflect",
    id: "fill1"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#97F2F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#C0F5FA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E0FAFC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: 913,
    y1: 147,
    x2: 913,
    y2: 527,
    gradientUnits: "userSpaceOnUse",
    spreadMethod: "reflect",
    id: "fill2"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#97F2F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#C0F5FA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E0FAFC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: 913,
    y1: 147,
    x2: 913,
    y2: 527,
    gradientUnits: "userSpaceOnUse",
    spreadMethod: "reflect",
    id: "fill3"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#97F2F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#C0F5FA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E0FAFC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: 913,
    y1: 147,
    x2: 913,
    y2: 527,
    gradientUnits: "userSpaceOnUse",
    spreadMethod: "reflect",
    id: "fill4"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#97F2F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#C0F5FA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E0FAFC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: 913,
    y1: 147,
    x2: 913,
    y2: 527,
    gradientUnits: "userSpaceOnUse",
    spreadMethod: "reflect",
    id: "fill5"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#97F2F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#C0F5FA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E0FAFC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: 913,
    y1: 147,
    x2: 913,
    y2: 527,
    gradientUnits: "userSpaceOnUse",
    spreadMethod: "reflect",
    id: "fill6"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#97F2F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#C0F5FA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E0FAFC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: 913,
    y1: 147,
    x2: 913,
    y2: 527,
    gradientUnits: "userSpaceOnUse",
    spreadMethod: "reflect",
    id: "fill7"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#97F2F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#C0F5FA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E0FAFC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: 913,
    y1: 147,
    x2: 913,
    y2: 527,
    gradientUnits: "userSpaceOnUse",
    spreadMethod: "reflect",
    id: "fill8"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#97F2F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#C0F5FA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E0FAFC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: 913,
    y1: 147,
    x2: 913,
    y2: 527,
    gradientUnits: "userSpaceOnUse",
    spreadMethod: "reflect",
    id: "fill9"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#97F2F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#C0F5FA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E0FAFC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: 913,
    y1: 147,
    x2: 913,
    y2: 527,
    gradientUnits: "userSpaceOnUse",
    spreadMethod: "reflect",
    id: "fill10"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#97F2F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#C0F5FA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E0FAFC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: 913,
    y1: 147,
    x2: 913,
    y2: 527,
    gradientUnits: "userSpaceOnUse",
    spreadMethod: "reflect",
    id: "fill11"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#97F2F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#C0F5FA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E0FAFC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: 913,
    y1: 147,
    x2: 913,
    y2: 527,
    gradientUnits: "userSpaceOnUse",
    spreadMethod: "reflect",
    id: "fill12"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#97F2F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#C0F5FA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E0FAFC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: 913,
    y1: 147,
    x2: 913,
    y2: 527,
    gradientUnits: "userSpaceOnUse",
    spreadMethod: "reflect",
    id: "fill13"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#97F2F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#C0F5FA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E0FAFC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: 913,
    y1: 147,
    x2: 913,
    y2: 527,
    gradientUnits: "userSpaceOnUse",
    spreadMethod: "reflect",
    id: "fill14"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#97F2F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#C0F5FA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E0FAFC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: 913,
    y1: 147,
    x2: 913,
    y2: 527,
    gradientUnits: "userSpaceOnUse",
    spreadMethod: "reflect",
    id: "fill15"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#97F2F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#C0F5FA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E0FAFC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: 913,
    y1: 147,
    x2: 913,
    y2: 527,
    gradientUnits: "userSpaceOnUse",
    spreadMethod: "reflect",
    id: "fill16"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#97F2F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#C0F5FA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E0FAFC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: 913,
    y1: 147,
    x2: 913,
    y2: 527,
    gradientUnits: "userSpaceOnUse",
    spreadMethod: "reflect",
    id: "fill17"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#97F2F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#C0F5FA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E0FAFC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: 913,
    y1: 147,
    x2: 913,
    y2: 527,
    gradientUnits: "userSpaceOnUse",
    spreadMethod: "reflect",
    id: "fill18"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#97F2F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#C0F5FA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E0FAFC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: 913,
    y1: 147,
    x2: 913,
    y2: 527,
    gradientUnits: "userSpaceOnUse",
    spreadMethod: "reflect",
    id: "fill19"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#97F2F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#C0F5FA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E0FAFC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: 913,
    y1: 147,
    x2: 913,
    y2: 527,
    gradientUnits: "userSpaceOnUse",
    spreadMethod: "reflect",
    id: "fill20"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#97F2F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#C0F5FA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E0FAFC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: 901,
    y1: 147,
    x2: 883,
    y2: 147,
    gradientUnits: "userSpaceOnUse",
    spreadMethod: "reflect",
    id: "fill21"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#D8D8D8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F2F2F2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: 897.691,
    y1: 426.776,
    x2: 883.309,
    y2: 472.224,
    gradientUnits: "userSpaceOnUse",
    spreadMethod: "reflect",
    id: "fill22"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#959595"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#D6D6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFFFFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: 970.04,
    y1: 406.572,
    x2: 894.96,
    y2: 307.428,
    gradientUnits: "userSpaceOnUse",
    spreadMethod: "reflect",
    id: "fill23"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#D8D8D8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F2F2F2"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip24"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 1052,
    y: 547,
    width: 133,
    height: 178
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip25"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 1052,
    y: 547,
    width: 133,
    height: 178
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip26"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 1052,
    y: 547,
    width: 133,
    height: 178
  })), /*#__PURE__*/React.createElement("image", {
    width: 580,
    height: 720,
    xlinkHref: "data:image/png;base64,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",
    preserveAspectRatio: "none",
    id: "img27"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip28"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M34.1269 720 580 720 580 0.000104987 91.0545 0.000104987 91.0545 0 0 0 0 720 34.1269 720Z",
    fillRule: "evenodd",
    clipRule: "evenodd"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)",
    transform: "translate(-98 -2)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 104,
    y: 4,
    width: 1080,
    height: 720,
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M907.979 507C814.188 507.086 738.086 431.097 738 337.274 737.959 292.107 755.899 248.783 787.858 216.876L790.747 219.772C726.274 284.42 726.398 389.111 791.024 453.606 855.649 518.101 960.304 517.977 1024.78 453.329 1089.25 388.681 1089.13 283.991 1024.5 219.496 977.036 172.128 905.67 158.133 843.842 184.07L842.258 180.297C928.786 143.956 1028.38 184.665 1064.71 271.222 1101.04 357.778 1060.34 457.407 973.814 493.747 952.969 502.502 930.587 507.008 907.979 507Z",
    fill: "url(#fill1)",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M908.084 517C808.635 517.008 728.008 436.414 728 336.987 727.992 239.313 805.887 159.45 903.552 157L903.66 161.095C816.917 163.362 744.747 228.45 733.584 314.482 721.097 410.811 789.081 499.021 885.431 511.505 946.755 519.451 1007.75 494.623 1046.08 446.111 1053.51 436.706 1059.96 426.571 1065.34 415.863L1069 417.698C1057.94 439.746 1042.47 459.291 1023.55 475.125 991.121 502.121 950.275 516.934 908.078 517Z",
    fill: "url(#fill2)",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M907.19 527C903.396 527 899.599 526.889 895.798 526.667 851.027 524.067 808.607 505.761 776 474.97L778.825 472.003C794.796 487.128 813.337 499.281 833.576 507.894 928.384 548.503 1038.16 504.562 1078.77 409.748 1119.37 314.935 1075.44 205.153 980.628 164.544 964.925 157.818 948.374 153.278 931.437 151.052L932.003 147C1036.48 160.711 1110.07 256.529 1096.36 361.015 1083.9 455.971 1002.98 526.98 907.218 527Z",
    fill: "url(#fill3)",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M893.484 449.246 887 486.765C908.956 490.538 931.477 489.525 953 483.797L943.09 447C926.915 451.309 909.988 452.075 893.484 449.246Z",
    fill: "url(#fill4)",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M801.186 313.19C807.398 283.496 824.945 257.497 850 240.868L829.349 209C796.022 231.136 772.684 265.732 764.426 305.24 763.887 307.816 763.412 310.392 763 312.968L800.141 319C800.433 317.065 800.781 315.129 801.186 313.19Z",
    fill: "url(#fill5)",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M844.611 429 822 458.952C826.409 462.214 830.996 465.235 835.739 468L855 435.839C851.412 433.751 847.944 431.467 844.611 429Z",
    fill: "url(#fill6)",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M805.56 376 770 389.307C777.645 410.214 789.644 429.209 805.181 445L832 417.87C820.324 405.995 811.307 391.716 805.56 376Z",
    fill: "url(#fill7)",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M859.118 438 841 470.858C846.976 473.965 853.157 476.685 859.5 479L873 444.081C868.24 442.355 863.602 440.323 859.118 438Z",
    fill: "url(#fill8)",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M866 481.626C868.655 482.481 871.361 483.272 874.118 484L884 447.775C881.952 447.237 879.929 446.646 877.93 446Z",
    fill: "url(#fill9)",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M953 444.243 966.179 480C1012.77 462.767 1048.12 423.952 1061 375.888L1024.26 366C1014.59 402.123 988.018 431.294 953 444.243Z",
    fill: "url(#fill10)",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M907 222.156 904.743 185C897.779 185.379 890.85 186.198 884 187.45L891.415 224C896.561 223.057 901.768 222.441 907 222.156Z",
    fill: "url(#fill11)",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M799.715 323.451 762.058 319C760.212 334.661 760.784 350.516 763.756 366L801 358.779C798.763 347.14 798.329 335.223 799.715 323.451Z",
    fill: "url(#fill12)",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M937.367 224.558C969.774 231.438 997.62 252.021 1013.73 281L1047 262.712C1019.59 213.425 967.346 183.196 911 184.016L911.567 222.022C920.235 221.895 928.889 222.745 937.367 224.558Z",
    fill: "url(#fill13)",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M868 231.174 852.994 197C846.8 199.635 840.789 202.666 835 206.075L854.472 238C858.823 235.435 863.342 233.155 868 231.174Z",
    fill: "url(#fill14)",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M801.201 363 765 371.717C765.339 373.153 765.688 374.582 766.066 376L802 366.226C801.719 365.16 801.452 364.085 801.201 363Z",
    fill: "url(#fill15)",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M859 194.043 872.503 230C877.232 228.161 882.075 226.641 887 225.451L878.288 188C871.734 189.577 865.29 191.596 859 194.043Z",
    fill: "url(#fill16)",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1065.98 334 1027.68 334.816C1027.79 342.079 1027.23 349.338 1026 356.497L1063.73 363C1065.39 353.426 1066.14 343.716 1065.98 334Z",
    fill: "url(#fill17)",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1027.16 324 1065 319.689C1063.29 304.268 1059.22 289.197 1052.93 275L1018 290.081C1022.79 300.85 1025.88 312.291 1027.16 324Z",
    fill: "url(#fill18)",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M776.5 464C772.358 464 769 467.134 769 471 769 474.866 772.358 478 776.5 478 780.642 478 784 474.866 784 471 784 467.134 780.642 464 776.5 464Z",
    fill: "url(#fill19)",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M777 478C772.582 478 769 474.642 769 470.5 769 466.358 772.582 463 777 463Z",
    fill: "url(#fill20)",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M734 352 808 352 808 375 734 375Z",
    fill: "#560F54",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M780 309 765 309 765 307 780 307Z",
    fill: "#BFBFBF",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M782 307 763 307 763 305 782 305Z",
    fill: "#D9D9D9",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M721 309 706 309 706 307 721 307Z",
    fill: "#BFBFBF",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M723 307 704 307 704 305 723 305Z",
    fill: "#D9D9D9",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M807 318.437C806.972 313.227 802.889 309.014 797.853 309L687.122 309C682.096 309.029 678.028 313.237 678 318.437L678 333 807 333Z",
    fill: "#D9D9D9",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M678 333 678 348.17C678.014 353.593 682.09 357.985 687.122 358L797.853 358C802.895 358 806.986 353.603 807 348.17L807 333Z",
    fill: "#BFBFBF",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M688 366.771 688 379 748 378.949 748 369.037 746.869 368.547 738.549 360 694.586 360 688 366.771Z",
    fill: "#560F54",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M852 369 852 375C853.223 374.51 854.015 373.343 853.998 372.056 854.047 370.732 853.252 369.517 852 369Z",
    fill: "#00A757",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M808 377 852 377 852 347 842.075 317 808 317 808 377Z",
    fill: "#FFFFF6",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M812 320 812 362.189C818.992 358.178 827.643 361.106 831.322 368.727 831.97 370.071 832.435 371.51 832.703 373L848 373 848 347.189 839.322 320Z",
    fill: "#D8E3DB",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M834.043 371 847 371 847 370.419 834.483 370.419C832.348 363.055 825.714 358.001 818.183 358 816.422 357.999 814.672 358.284 813 358.846L813.181 359.4C814.854 358.841 816.604 358.564 818.364 358.581 825.717 358.593 832.169 363.576 834.172 370.789Z",
    fill: "#FFFFF6",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M816 349 847 349 847 350 816 350Z",
    fill: "#FFFFF6",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M815 324 815 347 848 347 840.586 324 815 324Z",
    fill: "#560F54",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M840 322 840.689 324.112 849.745 324.112 852.245 326.738 851.378 326.738 851.378 338 855 338 855 326.738 850.561 322.027 850.561 322 840 322Z",
    fill: "#D8E3DB",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M691 376C691.071 383.201 696.871 389 704 389L704 363C696.871 363 691.071 368.799 691 376Z",
    fill: "#304153",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M704 363 704 389C710.627 389 716 383.18 716 376 716 368.82 710.627 363 704 363Z",
    fill: "#222C36",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M695 376.026C695 380.982 699.03 385 704 385L704 367C699.03 367 695 371.017 695 375.973 695 375.991 695 376.009 695 376.026Z",
    fill: "#FFFFF6",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M704 367.013 704 384.987C708.708 385.256 712.732 381.45 712.987 376.487 713.242 371.524 709.633 367.282 704.924 367.013 704.616 366.996 704.308 366.996 704 367.013Z",
    fill: "#D8E3DB",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M704 369C700.134 369 697 372.134 697 376 697 379.866 700.134 383 704 383 707.866 383 711 379.866 711 376 711 372.134 707.866 369 704 369ZM704 382.06C700.61 382.06 697.862 379.312 697.862 375.922 697.862 372.532 700.61 369.784 704 369.784 707.39 369.784 710.138 372.532 710.138 375.922 710.181 379.311 707.469 382.094 704.079 382.138 704.053 382.138 704.026 382.138 704 382.138Z",
    fill: "#333333",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M703 371.5C703 371.776 703.224 372 703.5 372 703.776 372 704 371.776 704 371.5 704 371.224 703.776 371 703.5 371 703.224 371 703 371.224 703 371.5Z",
    fill: "#333333",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M703 380.5C703 380.776 703.224 381 703.5 381 703.776 381 704 380.776 704 380.5 704 380.224 703.776 380 703.5 380 703.224 380 703 380.224 703 380.5Z",
    fill: "#333333",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M706.077 371.259C705.935 371.474 705.995 371.764 706.21 371.906 706.226 371.916 706.242 371.926 706.259 371.934 706.495 372.07 706.798 371.989 706.934 371.752 707.07 371.516 706.989 371.213 706.752 371.077 706.537 370.935 706.247 370.995 706.105 371.21 706.095 371.226 706.085 371.242 706.077 371.259Z",
    fill: "#333333",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M701.067 379.251C700.929 379.49 701.011 379.795 701.251 379.933 701.49 380.071 701.795 379.989 701.933 379.749 702.071 379.51 701.989 379.205 701.75 379.067 701.51 378.929 701.205 379.011 701.067 379.251Z",
    fill: "#333333",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M707.252 373.058C707.013 373.196 706.929 373.504 707.066 373.746 707.202 373.987 707.508 374.072 707.747 373.934 707.987 373.796 708.071 373.488 707.934 373.246 707.932 373.242 707.93 373.238 707.927 373.234 707.779 373.012 707.489 372.936 707.252 373.058Z",
    fill: "#333333",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M700.244 378.061C700.012 378.198 699.931 378.504 700.064 378.744 700.065 378.745 700.065 378.746 700.065 378.746 700.209 378.99 700.515 379.072 700.756 378.931 700.988 378.793 701.069 378.487 700.936 378.247 700.935 378.247 700.935 378.246 700.935 378.245 700.783 378.012 700.487 377.933 700.244 378.061Z",
    fill: "#333333",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M708.524 375.001C708.249 374.987 708.014 375.2 708.001 375.476 707.987 375.751 708.2 375.986 708.476 375.999 708.751 376.013 708.986 375.8 708.999 375.524 709 375.508 709 375.492 708.999 375.476 708.987 375.219 708.781 375.013 708.524 375.001Z",
    fill: "#333333",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M699.476 375.001C699.219 375.013 699.013 375.219 699.001 375.476 698.987 375.751 699.2 375.986 699.476 375.999 699.751 376.013 699.986 375.8 699.999 375.524 700.013 375.249 699.8 375.014 699.524 375.001 699.508 375 699.492 375 699.476 375.001Z",
    fill: "#333333",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M707.756 378.061C707.514 377.933 707.217 378.012 707.065 378.245 706.931 378.485 707.01 378.791 707.242 378.93 707.243 378.93 707.244 378.931 707.244 378.931 707.485 379.072 707.791 378.99 707.935 378.746 708.069 378.507 707.99 378.2 707.758 378.062 707.757 378.062 707.756 378.061 707.756 378.061Z",
    fill: "#333333",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M700.748 373.058C700.511 372.936 700.221 373.012 700.073 373.234 699.929 373.472 700.005 373.782 700.241 373.927 700.477 374.071 700.784 373.996 700.927 373.757 701.071 373.52 700.995 373.21 700.759 373.065 700.755 373.063 700.752 373.06 700.748 373.058Z",
    fill: "#333333",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M706.934 379.259C706.819 379.028 706.538 378.934 706.307 379.049 706.291 379.058 706.274 379.067 706.259 379.077 706.028 379.192 705.934 379.473 706.049 379.704 706.058 379.721 706.067 379.737 706.077 379.752 706.213 379.989 706.516 380.07 706.752 379.934 706.989 379.798 707.07 379.495 706.934 379.259Z",
    fill: "#333333",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M701.923 371.259C701.808 371.028 701.527 370.934 701.296 371.049 701.279 371.058 701.263 371.067 701.248 371.077 701.011 371.213 700.93 371.516 701.066 371.752 701.202 371.989 701.505 372.07 701.741 371.934 701.972 371.819 702.066 371.538 701.951 371.307 701.942 371.291 701.933 371.274 701.923 371.259Z",
    fill: "#333333",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M703 375.985C703 376.538 703.412 376.985 703.921 376.985 704.422 377.08 704.899 376.715 704.986 376.171 705.073 375.627 704.737 375.109 704.236 375.015 704.132 374.995 704.025 374.995 703.921 375.015 703.423 375.014 703.015 375.444 703 375.985Z",
    fill: "#333333",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M718 376C718.071 383.201 723.871 389 731 389L731 363C723.871 363 718.071 368.799 718 376Z",
    fill: "#304153",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M730 362.135 730 388.863C737.187 389.915 743.843 384.784 744.867 377.403 745.891 370.023 740.895 363.187 733.708 362.135 732.479 361.955 731.23 361.955 730 362.135Z",
    fill: "#222C36",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M722 376.026C722 380.972 725.578 384.986 730 385L730 367C725.582 367 722 371.006 722 375.947 722 375.973 722 376 722 376.026Z",
    fill: "#FFFFF6",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M730 367.013 730 384.987C734.708 385.256 738.732 381.45 738.987 376.487 739.242 371.524 735.633 367.282 730.924 367.013 730.616 366.996 730.308 366.996 730 367.013Z",
    fill: "#D8E3DB",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M730.5 369C726.91 369 724 372.134 724 376 724 379.866 726.91 383 730.5 383 734.09 383 737 379.866 737 376 737 372.134 734.09 369 730.5 369ZM730.5 382.06C727.353 381.987 724.856 379.181 724.923 375.792 724.991 372.403 727.596 369.714 730.744 369.786 733.871 369.858 736.36 372.631 736.321 376 736.322 379.39 733.77 382.139 730.622 382.139 730.582 382.139 730.541 382.139 730.5 382.138Z",
    fill: "#333333",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M730.001 371.524C730.013 371.781 730.219 371.987 730.476 371.999 730.751 372.013 730.986 371.8 730.999 371.524 731.013 371.249 730.8 371.014 730.524 371.001 730.249 370.987 730.014 371.2 730.001 371.476 730 371.492 730 371.508 730.001 371.524Z",
    fill: "#333333",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M730 380.5C730.013 380.771 730.224 380.987 730.487 381 730.761 381 730.986 380.78 731 380.5 731 380.225 730.783 380.001 730.514 380 730.505 380 730.496 380 730.487 380.001 730.218 380.001 730 380.225 730 380.5Z",
    fill: "#333333",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M732.067 371.251C731.929 371.49 732.011 371.795 732.251 371.933 732.49 372.071 732.795 371.989 732.933 371.749 733.071 371.51 732.989 371.205 732.749 371.067 732.51 370.929 732.205 371.011 732.067 371.251Z",
    fill: "#333333",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M728.065 379.261C727.931 379.498 728.01 379.802 728.242 379.939 728.243 379.939 728.244 379.94 728.244 379.94 728.486 380.066 728.783 379.988 728.935 379.757 729.069 379.52 728.99 379.217 728.758 379.08 728.757 379.079 728.756 379.079 728.756 379.079 728.53 378.931 728.229 378.998 728.085 379.228 728.078 379.239 728.071 379.25 728.065 379.261Z",
    fill: "#333333",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M734.254 373.065C734.01 373.209 733.928 373.515 734.069 373.756 734.207 373.988 734.513 374.069 734.753 373.936 734.753 373.935 734.754 373.935 734.755 373.935 734.988 373.783 735.067 373.486 734.939 373.244 734.802 373.012 734.496 372.931 734.256 373.064 734.255 373.065 734.254 373.065 734.254 373.065Z",
    fill: "#333333",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M726.251 378.067C726.011 378.205 725.929 378.51 726.067 378.749 726.205 378.989 726.51 379.071 726.749 378.933 726.989 378.795 727.071 378.49 726.933 378.251 726.795 378.011 726.49 377.929 726.251 378.067Z",
    fill: "#333333",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M734.5 375C734.224 375 734 375.224 734 375.5 734 375.776 734.224 376 734.5 376 734.776 376 735 375.776 735 375.5 735 375.224 734.776 375 734.5 375Z",
    fill: "#333333",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M725.5 375C725.224 375 725 375.224 725 375.5 725 375.776 725.224 376 725.5 376 725.776 376 726 375.776 726 375.5 726 375.224 725.776 375 725.5 375Z",
    fill: "#333333",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M734.749 378.067C734.511 377.929 734.206 378.011 734.068 378.249 734.068 378.25 734.067 378.25 734.067 378.251 733.929 378.49 734.011 378.795 734.251 378.933 734.49 379.071 734.795 378.989 734.933 378.75 735.071 378.511 734.989 378.206 734.751 378.068 734.751 378.068 734.75 378.067 734.749 378.067Z",
    fill: "#333333",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M726.755 373.065C726.515 372.931 726.209 373.01 726.07 373.242 726.07 373.243 726.069 373.244 726.069 373.244 725.928 373.485 726.01 373.791 726.254 373.935 726.493 374.069 726.8 373.99 726.938 373.758 726.939 373.757 726.939 373.756 726.939 373.756 727.067 373.514 726.988 373.217 726.755 373.065Z",
    fill: "#333333",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M732.923 379.259C732.808 379.028 732.527 378.934 732.296 379.049 732.279 379.058 732.263 379.067 732.248 379.077 732.011 379.213 731.93 379.516 732.066 379.752 732.202 379.989 732.505 380.07 732.741 379.934 732.972 379.819 733.066 379.538 732.951 379.307 732.942 379.291 732.933 379.274 732.923 379.259Z",
    fill: "#333333",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M728.935 371.261C728.808 371.02 728.513 370.93 728.277 371.059 728.266 371.065 728.255 371.072 728.244 371.079 728.012 371.215 727.931 371.518 728.064 371.755 728.065 371.756 728.065 371.757 728.065 371.757 728.217 371.988 728.514 372.066 728.756 371.94 728.988 371.804 729.069 371.501 728.936 371.263 728.935 371.263 728.935 371.262 728.935 371.261Z",
    fill: "#333333",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M730 375.971C729.992 376.523 730.209 376.984 730.486 377 730.762 377.016 730.992 376.581 731 376.029 731.008 375.477 730.791 375.016 730.514 375 730.505 375 730.495 375 730.486 375 730.221 375.016 730.008 375.442 730 375.971Z",
    fill: "#333333",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M819.517 352 817.503 352C817.233 352 817.011 351.784 817 351.51L817 351.51C817 351.228 817.225 351 817.503 351L819.517 351C819.787 351.011 820 351.236 820 351.51L820 351.51C820 351.781 819.784 352 819.517 352Z",
    fill: "#333333",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M795 366.473C795.014 370.082 797.696 373 801 373L801 360C797.716 360 795.041 362.885 795 366.473Z",
    fill: "#FFFFF6",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M801 360 801 373C803.946 372.768 806.179 369.669 805.989 366.079 805.815 362.813 803.68 360.211 801 360Z",
    fill: "#D8E3DB",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M748 360 771 360 771 380 748 380Z",
    fill: "#FFFFF6",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M771 360 793 360 793 380 771 380Z",
    fill: "#D8E3DB",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M737 359 737 360 696 360 696 359Z",
    fill: "#D8E3DB",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M737 358 737 359 696 359 696 358Z",
    fill: "#FFFFF6",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M735 359.516 745.127 370 746 369.096 736.222 359 735.524 359 735 359.516Z",
    fill: "#D8E3DB",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M698 359.516 687.875 370 687 369.096 696.775 359 697.5 359 698 359.516Z",
    fill: "#D8E3DB",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M736 358.873 736.35 359.222 736.375 359.222 736.85 359.721 736.85 359.721 736.975 359.846 737 359.846 746.125 369 747 368.127 746.45 367.578 738.725 359.846 736.875 358 736 358.873Z",
    fill: "#FFFFF6",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M686 368.127 686.85 369 687.725 368.127 687.725 368.127 696.625 359.222 697 358.873 696.125 358 694.275 359.846 687.725 366.406 686 368.127Z",
    fill: "#FFFFF6",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M805 359 783 359 783 339 805 339Z",
    fill: "#FFFFF6",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M805 359 793 359 793 339 805 339Z",
    fill: "#D8E3DB",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M806 376C806.071 383.201 811.871 389 819 389L819 363C811.871 363 806.071 368.799 806 376Z",
    fill: "#304153",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M818 363 818 389C825.18 389 831 383.18 831 376 831 368.82 825.18 363 818 363Z",
    fill: "#222C36",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M810 376.026C810 380.982 813.582 385 818 385L818 367C813.595 366.985 810.013 370.979 810 375.921 810 375.956 810 375.991 810 376.026Z",
    fill: "#FFFFF6",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M818 367 818 385C823.247 384.731 827.27 380.483 826.986 375.512 826.723 370.918 822.85 367.249 818 367Z",
    fill: "#D8E3DB",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M818.5 369C814.91 369 812 372.134 812 376 812 379.866 814.91 383 818.5 383 822.09 383 825 379.866 825 376 825 372.134 822.09 369 818.5 369ZM818.5 382.06C815.352 382.074 812.789 379.338 812.776 375.948 812.763 372.558 815.304 369.798 818.451 369.784 821.599 369.769 824.162 372.506 824.175 375.896 824.175 375.904 824.175 375.913 824.175 375.922 824.216 379.311 821.697 382.094 818.549 382.138 818.533 382.138 818.516 382.138 818.5 382.138Z",
    fill: "#333333",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M818.013 371.125C818.026 371.616 818.246 372.001 818.513 372 818.769 371.977 818.975 371.599 818.987 371.125 819.049 370.63 818.88 370.136 818.611 370.023 818.342 369.91 818.074 370.22 818.013 370.716 817.996 370.851 817.996 370.991 818.013 371.125Z",
    fill: "#333333",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M818.001 380.513C818.014 380.786 818.24 381 818.513 381 818.776 380.987 818.987 380.777 818.999 380.513 819.013 380.245 818.808 380.016 818.539 380.001 818.53 380.001 818.522 380.001 818.513 380.001 818.245 379.986 818.015 380.192 818.001 380.46 818 380.478 818 380.496 818.001 380.513Z",
    fill: "#333333",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M820.066 371.26C819.931 371.498 820.01 371.802 820.244 371.939 820.244 371.939 820.245 371.94 820.246 371.94 820.489 372.066 820.788 371.988 820.94 371.757 821.07 371.516 820.982 371.215 820.745 371.083 820.742 371.081 820.738 371.079 820.734 371.077 820.521 370.935 820.234 370.995 820.093 371.212 820.083 371.227 820.074 371.244 820.066 371.26Z",
    fill: "#333333",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M816.077 379.259C815.935 379.474 815.995 379.764 816.21 379.906 816.226 379.916 816.242 379.926 816.259 379.934 816.495 380.07 816.798 379.989 816.934 379.752 817.07 379.516 816.989 379.213 816.752 379.077 816.537 378.935 816.247 378.995 816.105 379.21 816.095 379.226 816.085 379.242 816.077 379.259Z",
    fill: "#333333",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M822.254 373.065C822.01 373.209 821.928 373.515 822.069 373.756 822.207 373.988 822.513 374.069 822.753 373.936 822.753 373.935 822.754 373.935 822.755 373.935 822.988 373.783 823.067 373.486 822.939 373.244 822.802 373.012 822.496 372.931 822.256 373.064 822.255 373.065 822.254 373.065 822.254 373.065Z",
    fill: "#333333",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M814.248 378.066C814.012 378.202 813.93 378.503 814.065 378.739 814.066 378.74 814.066 378.741 814.066 378.741 814.182 378.972 814.462 379.066 814.693 378.951 814.71 378.942 814.726 378.933 814.741 378.923 814.972 378.808 815.066 378.527 814.951 378.296 814.942 378.28 814.933 378.264 814.923 378.248 814.787 378.012 814.486 377.93 814.25 378.065 814.249 378.066 814.249 378.066 814.248 378.066Z",
    fill: "#333333",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M822.5 375C822.229 375.013 822.013 375.224 822 375.487 822 375.761 822.22 375.986 822.5 376 822.775 376 823 375.783 823 375.514 823 375.505 823 375.496 822.999 375.487 822.999 375.218 822.775 375 822.5 375Z",
    fill: "#333333",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M814.5 375C814.224 375 814 375.224 814 375.5 814 375.776 814.224 376 814.5 376 814.776 376 815 375.776 815 375.5 815 375.224 814.776 375 814.5 375Z",
    fill: "#333333",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M822.749 378.067C822.511 377.929 822.206 378.011 822.068 378.249 822.068 378.25 822.067 378.25 822.067 378.251 821.929 378.49 822.011 378.795 822.25 378.933 822.49 379.071 822.795 378.989 822.933 378.75 823.071 378.511 822.989 378.206 822.751 378.068 822.751 378.068 822.75 378.067 822.749 378.067Z",
    fill: "#333333",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M814.739 373.065C814.502 372.931 814.198 373.01 814.061 373.242 814.061 373.243 814.06 373.244 814.06 373.244 813.934 373.486 814.012 373.783 814.243 373.935 814.48 374.069 814.783 373.99 814.92 373.758 814.921 373.757 814.921 373.756 814.921 373.756 815.069 373.53 815.002 373.229 814.772 373.085 814.761 373.078 814.75 373.071 814.739 373.065Z",
    fill: "#333333",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M820.94 379.26C820.812 379.02 820.516 378.93 820.278 379.059 820.267 379.065 820.256 379.071 820.246 379.078 820.011 379.214 819.93 379.516 820.065 379.752 820.201 379.989 820.5 380.07 820.734 379.934 820.974 379.81 821.069 379.513 820.946 379.271 820.944 379.267 820.942 379.263 820.94 379.26Z",
    fill: "#333333",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M816.933 371.251C816.795 371.011 816.49 370.929 816.251 371.067 816.011 371.205 815.929 371.51 816.067 371.749 816.205 371.989 816.51 372.071 816.749 371.933 816.989 371.795 817.071 371.49 816.933 371.251Z",
    fill: "#333333",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M818.007 375.829C817.96 376.373 818.143 376.891 818.415 376.985 818.687 377.08 818.945 376.715 818.993 376.171 819.003 376.058 819.003 375.942 818.993 375.829 818.945 375.285 818.687 374.92 818.415 375.015 818.207 375.087 818.043 375.413 818.007 375.829Z",
    fill: "#333333",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1026 176.228C1026 161.191 1014.43 149 1000.16 149L819.843 149C805.57 149 794 161.191 794 176.228L794 184 1026 184Z",
    fill: "#D9D9D9",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1026 184 1026 191.403C1026.04 206.047 1014.51 217.954 1000.24 218 1000.21 218 1000.18 218 1000.16 218L819.843 218C805.57 218 794 206.129 794 191.485 794 191.458 794 191.431 794 191.403L794 184Z",
    fill: "#BFBFBF",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M883 145 901 145 901 149 883 149Z",
    fill: "url(#fill21)",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M881 140 903 140 903 145 881 145Z",
    fill: "#560F54",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M884 218 897 218 897 225 884 225Z",
    fill: "#2F8F9E",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M906 218 913 218 913 224 906 224Z",
    fill: "#2F8F9E",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M927 218 940 218 940 225 927 225Z",
    fill: "#2F8F9E",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M821 218 835 218 835 223 821 223Z",
    fill: "#2F8F9E",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M985 218 1000 218 1000 223 985 223Z",
    fill: "#2F8F9E",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M823 149 832 149 832 185 823 185Z",
    fill: "#BFBFBF",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M988 149 997 149 997 185 988 185Z",
    fill: "#BFBFBF",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M823 184 832 184 832 218 823 218Z",
    fill: "#D9D9D9",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M988 184 997 184 997 218 988 218Z",
    fill: "#D9D9D9",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M910 149 911 149 911 224 910 224Z",
    fill: "#FFFFFF",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M921 149 923 149 923 224 921 224Z",
    fill: "#FFFFFF",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M911 209 921 209 921 211 911 211Z",
    fill: "#FFFFFF",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M911 202 921 202 921 203 911 203Z",
    fill: "#FFFFFF",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M911 194 921 194 921 195 911 195Z",
    fill: "#FFFFFF",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M911 187 921 187 921 188 911 188Z",
    fill: "#FFFFFF",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M911 179 921 179 921 180 911 180Z",
    fill: "#FFFFFF",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M911 172 921 172 921 173 911 173Z",
    fill: "#FFFFFF",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M911 164 921 164 921 165 911 165Z",
    fill: "#FFFFFF",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M911 156 921 156 921 158 911 158Z",
    fill: "#FFFFFF",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M793 224 1027 224 1027 233 793 233Z",
    fill: "#560F54",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1048 305 1100 305 1100 335 1048 335Z",
    fill: "#A6A6A6",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1048 335 1100 335 1100 389 1048 389Z",
    fill: "#00BAC6",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1074 305 1100 305 1100 335 1074 335Z",
    fill: "#A6A6A6",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1074 335 1100 335 1100 389 1074 389Z",
    fill: "#00BAC6",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1048 335 1074 335 1074 338 1048 338Z",
    fill: "#0070C0",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1074 335 1100 335 1100 338 1074 338Z",
    fill: "#0070C0",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1051 309 1097 309 1097 333 1051 333Z",
    fill: "#D8E3DB",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1051 309 1074 309 1074 333 1051 333Z",
    fill: "#560F54",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1074 309 1097 309 1097 333 1074 333Z",
    fill: "#560F54",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1053 312 1074 312 1074 330 1053 330Z",
    fill: "#FFFFF6",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1074 312 1095 312 1095 330 1074 330Z",
    fill: "#D8E3DB",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1103 285 1110 285 1110 389 1103 389Z",
    fill: "#D8E3DB",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1037 285 1045 285 1045 389 1037 389Z",
    fill: "#FFFFF6",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1037 389 1074 389 1074 401 1037 401Z",
    fill: "#FFFFF6",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1074 389 1110 389 1110 401 1074 401Z",
    fill: "#D8E3DB",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1030 401 1074 401 1074 403 1030 403Z",
    fill: "#D8E3DB",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1074 401 1118 401 1118 403 1074 403Z",
    fill: "#FFFFF6",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1030 268 1074 268 1074 285 1030 285Z",
    fill: "#FFFFF6",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1074 268 1118 268 1118 285 1074 285Z",
    fill: "#D8E3DB",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1025 264 1074 264 1074 268 1025 268Z",
    fill: "#D8E3DB",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1074 264 1123 264 1123 268 1074 268Z",
    fill: "#FFFFF6",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1057 340 1062 340 1062 361 1057 361Z",
    fill: "#939598",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1058 349 1062 349 1062 359 1058 359Z",
    fill: "#E6E7E8",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1044.58 395C1035.4 394.924 1028 388.728 1028 381.111L1028 307.861C1028 303.573 1032.14 300.076 1037.31 300L1037.31 302.139C1033.5 302.139 1030.41 304.701 1030.41 307.861L1030.41 381.25C1030.41 387.663 1036.68 392.861 1044.42 392.861 1052.15 392.861 1058.42 387.663 1058.42 381.25L1058.42 358.5 1061 358.5 1061 381.25C1060.91 388.759 1053.64 394.85 1044.58 395Z",
    fill: "#0F0F38",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1085 340 1090 340 1090 361 1085 361Z",
    fill: "#939598",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1086 350 1090 350 1090 359 1086 359Z",
    fill: "#E6E7E8",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.5838 95C7.39777 94.9238-0.000448475 88.7278 0 81.1111L0 7.86112C-0.000807255 3.5732 4.14292 0.0757565 9.31371 0L9.31371 2.13888C5.5021 2.13888 2.4122 4.70082 2.4122 7.86112L2.4122 81.25C2.4122 87.6627 8.68202 92.8611 16.4163 92.8611 24.1505 92.8611 30.4203 87.6627 30.4203 81.25L30.4203 58.5 33 58.5 33 81.25C32.9113 88.7594 25.6394 94.8502 16.5838 95Z",
    fill: "#0F0F38",
    fillRule: "evenodd",
    transform: "matrix(-1 0 0 1 1119 300)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1085 341.625C1085 341.97 1086.12 342.25 1087.5 342.25 1088.88 342.25 1090 341.97 1090 341.625L1090 351.375C1090 351.72 1088.88 352 1087.5 352 1086.12 352 1085 351.72 1085 351.375Z",
    fill: "#FF0000",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1085 341.625C1085 341.28 1086.12 341 1087.5 341 1088.88 341 1090 341.28 1090 341.625 1090 341.97 1088.88 342.25 1087.5 342.25 1086.12 342.25 1085 341.97 1085 341.625Z",
    fill: "#FF6666",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1058 341.5C1058 341.776 1058.9 342 1060 342 1061.1 342 1062 341.776 1062 341.5L1062 351.5C1062 351.776 1061.1 352 1060 352 1058.9 352 1058 351.776 1058 351.5Z",
    fill: "#008E40",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1058 341.5C1058 341.224 1058.9 341 1060 341 1061.1 341 1062 341.224 1062 341.5 1062 341.776 1061.1 342 1060 342 1058.9 342 1058 341.776 1058 341.5Z",
    fill: "#66BB8C",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M979 529.104C979 529.104 984.355 540.864 989.355 546.85 993.947 552.371 1011.76 556.932 1011.76 556.932 1012.57 557.134 1013.42 556.878 1013.98 556.266 1015.42 554.835 1015.49 551.678 1013.16 551.119 1013.16 551.119 997.528 545.832 992.414 540.571 989.027 537.102 987.059 532.301 986.129 529.437 985.647 527.959 985.459 527 985.459 527Z",
    fill: "#7F7F7F",
    fillRule: "evenodd",
    fillOpacity: 0.811765
  }), /*#__PURE__*/React.createElement("path", {
    d: "M979 529.086C979 529.086 984.358 540.853 989.361 546.844 993.955 552.368 1011.78 556.932 1011.78 556.932 1012.58 557.134 1013.44 556.878 1014 556.266 1008.88 554.893 1003.69 553.754 998.844 551.601 992.723 548.936 987.003 544.205 985.309 537.755 984.59 534.974 984.877 532.03 986.119 529.439L986.119 529.439C985.637 527.96 985.45 527 985.45 527Z",
    fill: "#7F7F7F",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M927.007 477.089C929.356 479.114 941.098 487.755 950.074 499.15 957.41 508.452 960.758 514.217 961.201 516.918 963.49 519.402 965.322 521.299 968.63 522.831 968.63 522.831 968.63 522.831 968.63 522.831L969 523 949.155 457.519 948.698 456C948.698 456 941.144 456 937.969 456.783 937.803 456.817 937.525 457.107 937.168 457.593 934.436 461.245 926.729 476.137 927.007 477.089Z",
    fill: "#26A1AA",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M931 492.199C931.536 492.926 932.154 493.592 932.844 494.184 934.844 496.169 938.211 499.272 941.687 502.361 944.653 505.008 947.667 507.654 949.912 509.493 950.889 510.337 951.933 511.104 953.034 511.789L953.034 511.789C953.067 511.8 953.1 511.816 953.129 511.835L953.327 511.908 953.327 511.908C954.578 512.179 957.347 511.796 959.19 511.478 960.245 511.299 961 511.141 961 511.141 955.385 502.087 948.769 493.657 941.272 486Z",
    fill: "#B1EAEE",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M931 492.313C931.536 493.054 932.154 493.734 932.843 494.338L941.934 491.462 958.933 511.575 959.191 512C960.245 511.818 961 511.656 961 511.656 955.388 502.417 948.775 493.814 941.281 486Z",
    fill: "#BFBFBF",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M929 492C929 492 944.863 507.757 946.722 508.98 948.74 510.128 950.838 511.137 953 512 949.728 510.269 930.687 492.621 930.906 492.214Z",
    fill: "#A6A6A6",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M928.161 515.609C928.534 516.32 928.98 516.991 929.493 517.61 929.963 518.15 930.475 518.652 931.025 519.111 934.062 521.779 938.351 523.453 942.534 524.507 948.429 525.98 954.043 526.154 955.409 525.907 958.073 525.434 965 519.237 965 519.237L962.616 514.976 962.542 515.049C961.803 515.783 955.808 521.659 954.043 521.959 952.924 522.145 948.289 521.465 943.207 519.291 942.069 518.812 940.957 518.273 939.876 517.677 937.391 516.329 935.125 514.611 933.156 512.581 932.386 511.788 931.676 510.939 931.031 510.04 926.162 503.371 927.035 496.914 927.961 494.44 928.101 494.047 929.366 493.106 931.085 491.999 935.234 489.331 942.021 485.496 942.021 485.496L935.361 479C935.361 479 933.489 480.494 931.098 482.522 927.155 485.856 921.82 490.618 921.194 492.473 920.228 495.44 922.925 506.012 928.161 515.609Z",
    fill: "#F2F2F2",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M930.079 518 929.984 517.651C929.463 517.029 929.009 516.354 928.629 515.64 923.305 505.99 920.561 495.361 921.591 492.364 922.62 489.366 936 478.818 936 478.818L928.298 478C928.298 478 917.458 488.696 917.038 491.445 916.618 494.194 919.565 510.101 930.079 518Z",
    fill: "#D9D9D9",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M940 517.769C946.313 521.162 952.937 522.193 954.319 521.971 956.107 521.678 962.177 515.93 962.926 515.212L963 515.14 959.506 513C959.506 513 952.525 519.433 951.129 519.838 950.063 520.105 943.197 518.533 940 517.769Z",
    fill: "#A6A6A6",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M972 520.411C972 520.411 972.78 522.037 973.786 523.907 974.865 525.874 976.216 528.196 977.145 529.016 977.533 529.36 977.989 529.617 978.483 529.77 979.769 530.13 981.134 530.066 982.381 529.586 982.78 529.445 983.17 529.274 983.544 529.075 984.524 528.611 985.33 527.841 985.843 526.878 985.954 526.629 986.007 526.357 985.999 526.084 985.967 525.33 984.927 520.995 984.174 517.978 983.758 516.279 983.433 515 983.433 515Z",
    fill: "#BFBFBF",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M972 520.404C972 520.404 972.832 522.037 973.906 523.907 974.761 524.396 975.521 525.022 976.151 525.756 977.168 527.034 978.094 528.375 978.923 529.77 980.294 530.13 981.751 530.066 983.081 529.586 982.512 528.577 981.951 527.566 981.376 526.556 980.988 525.848 979.948 524.622 980.108 523.769 980.185 523.448 980.334 523.146 980.544 522.883 981.794 521.069 983.292 519.419 985 517.978 984.55 516.279 984.203 515 984.203 515Z",
    fill: "#A6A6A6",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M936.006 477.301C936.24 478.36 942.246 483.501 948.759 491.105 950.763 493.419 952.767 495.962 954.705 498.688 957.611 502.953 960.229 507.412 962.54 512.033 965.346 517.431 967.451 521.897 968.633 522.828 968.633 522.828 968.633 522.828 968.633 522.828 968.737 522.923 968.868 522.982 969.007 522.997 970.811 523.044 980.791 522.626 986.095 514.287 987.197 512.553 987.231 510.239 986.529 507.682 984.565 500.402 976.823 490.693 970.864 483.845 967.524 480.006 964.745 477.098 963.856 475.971 960.937 472.335 965.68 463.085 963.856 461.128 961.772 458.848 955.974 457.08 952.059 456.331 950.895 456.047 949.694 455.945 948.499 456.028 947.75 456.223 945.359 459.786 942.86 463.949 939.46 469.677 935.826 476.531 936.006 477.301Z",
    fill: "#54D1D9",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M949 491.335C950.994 493.62 952.988 496.132 954.915 498.823 957.807 503.034 960.412 507.437 962.712 512 965.733 504.105 968.229 496.017 970.183 487.791 970.468 486.578 970.741 485.379 971 484.167 967.677 480.376 964.912 477.505 964.028 476.393 961.123 472.802 965.842 463.668 964.028 461.737 961.954 459.485 956.185 457.739 952.29 457Z",
    fill: "#FFFFFF",
    fillRule: "evenodd",
    fillOpacity: 0.541176
  }), /*#__PURE__*/React.createElement("path", {
    d: "M982.815 506.51C983.588 508.023 984.32 509.713 983.855 511.341 983.465 512.698 982.323 513.708 981.168 514.59 979.401 515.934 977.499 517.093 975.494 518.05 974.422 518.651 973.217 518.977 971.986 519 970.636 518.885 969.376 518.276 968.452 517.29 967.578 516.326 966.835 515.252 966.244 514.095L955.053 494.367C953.685 491.999 952.318 489.238 953.378 486.721 955.189 482.386 962.374 481.972 965.683 484.787 970.18 488.625 974.168 493.013 977.551 497.847 979.513 500.606 981.273 503.501 982.815 506.51Z",
    fill: "#560F54",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M946.392 457.472C944.311 460.739 942.442 464.139 940.799 467.65 941.558 466.422 942.298 465.214 943.071 464.027 944.523 461.795 945.807 459.447 947.428 457.323 948.187 456.326 949.196 456.387 950.312 456.516 951.607 456.66 952.891 456.886 954.157 457.194 956.273 457.707 958.337 458.416 960.323 459.311 961.896 459.99 964.141 460.756 964.417 462.704 964.484 463.634 964.375 464.569 964.094 465.458L962.945 470.038C962.595 471.395 962.118 472.711 962.454 474.15 962.779 475.18 963.334 476.123 964.074 476.905L965.109 478.167C968.471 482.238 971.739 486.593 975.477 490.305 978.907 493.86 981.812 497.896 984.102 502.287 985.104 504.126 986.119 506.066 987 508 983.914 496.574 966.656 479.191 964.182 476.111 961.244 472.454 966.017 463.152 964.182 461.184 961.183 457.9 950.507 455.613 948.718 456.054 948.718 456.054 941.041 456.054 937.813 456.841 937.645 456.875 937.363 457.167 937 457.656 938.614 457.35 940.664 457.065 940.967 457.052 942.594 456.943 944.9 456.713 946.392 457.472Z",
    fill: "#2EC1CC",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M922.327 464.612C922.463 464.92 922.654 465.199 922.889 465.436 926.342 468.867 928.497 471.352 931.061 474.358 933.162 476.809 937.987 471.812 940.477 466.623 940.813 465.936 941.106 465.228 941.354 464.502 941.923 463.085 942.121 461.54 941.929 460.02 941.808 459.336 941.461 458.715 940.945 458.263 938.015 455.955 934.865 453.957 931.542 452.298 931.194 452.114 930.81 452.013 930.418 452.003 926.978 451.839 922.494 457.872 922.052 462.189 921.929 463.007 922.024 463.844 922.327 464.612Z",
    fill: "#A6A6A6",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M929 457.781C933.422 459.198 937.592 461.297 941.359 464 941.923 462.638 942.12 461.154 941.93 459.694 938.21 457.127 934.272 454.887 930.161 453Z",
    fill: "#BFBFBF",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M923.642 463.276C926.075 466.521 928.73 469.58 931.587 472.43 931.901 472.676 932.121 473.03 932.208 473.428 932.249 473.987 931.71 474.186 931.307 474.072 934.394 477.981 940.01 468.409 941 466.285 940.294 467.137 939.514 467.921 938.671 468.628 938.303 468.808 937.912 468.93 937.509 468.989 936.882 469.07 936.244 468.957 935.679 468.663 932.734 467.162 929.968 464.649 927.235 462.737 925.969 461.89 924.375 461.765 923 462.405Z",
    fill: "#BFBFBF",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M922.338 464.249C923.347 465.581 925.046 464.982 926.243 463.696 928.605 461.086 931.143 457.098 930.994 453.409 930.987 452.887 930.747 452.396 930.343 452.077L930.206 452.004C926.119 451.791 920.568 460.44 922.338 464.249Z",
    fill: "#A6A6A6",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M853.529 444.905C853.676 444.939 854.199 445.039 855.031 445.179 864.21 446.833 911.429 454.937 915.238 456.358 919.435 457.939 923.231 461.741 923.231 461.741 924.022 462.268 924.961 461.948 925.879 461.167 927.158 459.977 928.194 458.553 928.93 456.972 929.882 455.044 930.332 453.217 929.721 452.87 929.721 452.87 921.112 446.7 918.772 446.139 916.431 445.579 862.152 438.135 854.239 437.121L853.361 437.008C850.156 436.728 850.216 444.152 853.529 444.905Z",
    fill: "url(#fill22)",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M853.543 445.16C854.017 445.243 854.503 445.121 854.885 444.822 855.129 444.662 855.326 444.437 855.456 444.172 855.456 444.089 855.55 443.343 855.55 443.343 875.486 447.42 907.802 451.635 914.935 454.143 919.17 455.804 922.949 458.5 925.947 462 927.227 460.767 928.263 459.291 929 457.654 928.707 457.941 928.318 458.102 927.913 458.103 927.278 458.052 926.665 457.841 926.128 457.488 923.87 456.31 921.681 454.997 919.572 453.556 917.693 452.208 914.935 451.787 912.708 451.227 907.467 449.928 902.132 449.092 896.811 448.263L855.724 441.809C855.659 440.881 855.54 439.958 855.369 439.045 855.157 438.101 854.471 437.347 853.57 437.069 852.054 436.64 851.269 438.306 851.081 439.598 850.876 440.916 851.063 442.267 851.618 443.474 851.984 444.303 852.69 444.921 853.543 445.16Z",
    fill: "#FFFFFF",
    fillRule: "evenodd",
    fillOpacity: 0.388235
  }), /*#__PURE__*/React.createElement("path", {
    d: "M852.872 438C850.146 437.932 850.529 444.813 853.167 444.997 855.923 445.161 855.363 438.069 852.872 438Z",
    fill: "#595959",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M931 492C935.174 489.332 942 485.497 942 485.497L935.301 479C935.301 479 933.418 480.494 931.013 482.522Z",
    fill: "#FFFFFF",
    fillRule: "evenodd",
    fillOpacity: 0.611765
  }), /*#__PURE__*/React.createElement("path", {
    d: "M931 519.403C933.993 522.17 938.221 523.907 942.344 525L943 519.596C941.879 519.1 940.783 518.541 939.718 517.922 937.268 516.524 935.035 514.742 933.094 512.636 932.335 511.813 931.635 510.932 931 510Z",
    fill: "#000000",
    fillRule: "evenodd",
    fillOpacity: 0.168627
  }), /*#__PURE__*/React.createElement("path", {
    d: "M941 501.977C944.04 504.583 947.13 507.189 949.431 509L951 502.733 944.152 495Z",
    fill: "#FFFFFF",
    fillRule: "evenodd",
    fillOpacity: 0.85098
  }), /*#__PURE__*/React.createElement("path", {
    d: "M929 454.058C929 454.058 920.383 447.749 918.879 447.468 917.374 447.188 854 438 854 438L854.904 439.306C854.904 439.306 917.05 448.193 918.366 448.877 919.682 449.56 928.454 456 928.454 456Z",
    fill: "#FFFFFF",
    fillRule: "evenodd",
    fillOpacity: 0.388235
  }), /*#__PURE__*/React.createElement("path", {
    d: "M982.755 525.814C983.163 526.874 983.56 527.934 983.963 529 984.831 528.556 985.545 527.82 986 526.899 985.425 524.541 984.308 522.227 983.549 520 982.59 520.444 981.977 521.48 982.001 522.615 982.048 523.727 982.305 524.815 982.755 525.814Z",
    fill: "#FFFFFF",
    fillRule: "evenodd",
    fillOpacity: 0.45098
  }), /*#__PURE__*/React.createElement("path", {
    d: "M987 534C990.293 540.766 996.073 545.823 1003 548 999.24 548.008 995.588 546.686 992.63 544.245 989.739 541.568 987.762 537.97 987 534Z",
    fill: "#FFFFFF",
    fillRule: "evenodd",
    fillOpacity: 0.301961
  }), /*#__PURE__*/React.createElement("path", {
    d: "M930.73 452.201C930.993 452.339 931.223 452.531 931.403 452.763 932.352 453.933 932.029 455.653 931.403 456.895 930.777 458.137 929.855 458.934 929.141 460 929.924 458.822 930.491 457.522 930.818 456.156 931.131 455.288 931.243 454.364 931.147 453.449 931.071 452.987 930.774 452.587 930.346 452.371 929.918 452.196 929.438 452.182 929 452.332 929.493 451.943 930.181 451.891 930.73 452.201Z",
    fill: "#E8FEFF",
    fillRule: "evenodd",
    fillOpacity: 0.419608
  }), /*#__PURE__*/React.createElement("path", {
    d: "M918.052 447.876C918.052 447.876 918.052 447.955 918.076 447.991 918.122 448.137 918.186 448.26 918.263 448.351 918.292 448.395 918.306 448.456 918.34 448.492L918.34 448.492 918.34 448.492 918.412 448.606 918.541 448.729C918.645 448.837 918.759 448.908 918.877 448.94 918.939 448.967 919.002 448.982 919.065 448.984L919.175 448.984C919.266 449.006 919.358 449.006 919.448 448.984 919.517 448.987 919.584 448.972 919.65 448.94L919.741 448.869 919.775 448.869 919.899 448.773 919.899 448.773C919.937 448.703 919.968 448.623 919.991 448.535 920.003 448.47 920.003 448.399 919.991 448.333 919.985 448.262 919.977 448.192 919.967 448.122 919.969 448.073 919.969 448.023 919.967 447.973 919.945 447.899 919.917 447.831 919.885 447.771 919.839 447.684 919.788 447.607 919.732 447.542 919.664 447.458 919.593 447.382 919.52 447.314 919.473 447.253 919.424 447.2 919.372 447.156L919.372 447.156C919.302 447.09 919.228 447.039 919.151 447.006 919.108 446.998 919.065 446.998 919.021 447.006L918.541 447.006C918.43 447.013 918.321 447.07 918.225 447.173L918.158 447.261 918.09 447.349C918.051 447.417 918.021 447.501 918.004 447.595 917.999 447.636 917.999 447.678 918.004 447.718L918.004 447.718C918.011 447.779 918.027 447.834 918.052 447.876Z",
    fill: "#E8FEFF",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M921 448 920.637 448 920 447Z",
    fill: "#E8FEFF",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M856.11 438.099C857.093 437.926 858.096 437.98 859.062 438.257 860.126 438.487 861.198 438.701 862.262 438.891 864.491 439.203 866.694 439.732 868.849 440.474 868.896 440.474 869.084 440.608 868.956 440.664 868.126 440.967 867.251 441.067 866.386 440.956 865.198 440.875 864.013 440.722 862.838 440.497 860.588 440.102 858.152 439.848 856.143 438.463 856.023 438.368 855.909 438.147 856.11 438.099Z",
    fill: "#E8FEFF",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M983 528.165 983.049 528.013C983.038 527.965 983.038 527.915 983.049 527.867 983.057 527.818 983.069 527.769 983.083 527.721 983.106 527.635 983.136 527.552 983.173 527.472 983.234 527.348 983.308 527.232 983.395 527.125L983.582 526.903C983.744 526.734 983.922 526.583 984.116 526.452 984.339 526.305 984.57 526.17 984.809 526.049 984.974 525.984 985.157 525.984 985.322 526.049L985.564 526.14C985.62 526.14 985.744 526.237 985.765 526.306 985.865 526.527 985.933 526.76 985.966 527 986.011 527.208 986.011 527.423 985.966 527.631 985.932 527.721 985.897 527.812 985.855 527.902 985.795 528.019 985.718 528.127 985.627 528.221 985.455 528.404 985.241 528.542 985.003 528.623L984.85 528.72C984.747 528.773 984.638 528.813 984.525 528.838L984.31 528.929C984.207 528.957 984.103 528.978 983.998 528.991 983.837 529.012 983.673 528.996 983.52 528.942 983.416 528.942 983.215 528.845 983.166 528.727 983.127 528.616 983.11 528.498 983.118 528.38 983.058 528.322 983.017 528.247 983 528.165Z",
    fill: "#E8FEFF",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M859.238 463.554C862.208 469.855 865.85 475.975 868.562 482.35 870.906 487.869 872.558 493.709 871.824 499.435 871.043 505.677 867.247 511.166 861.63 514.175 856.634 516.723 850.923 517.579 845.381 516.614 837.308 515.224 830.627 509.972 828.765 501.914 826.556 492.392 829.485 481.361 833.019 472.467 836.542 463.577 841.703 455.402 848.242 448.353 849.513 447.016 851.212 444.343 853.156 444.029 854.386 443.836 854.053 444.624 854.107 445.646 854.161 446.669 854.311 447.651 854.399 448.653 854.575 450.412 854.912 452.152 855.405 453.852 856.413 457.183 857.695 460.427 859.238 463.554Z",
    fill: "#05EDFF",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M864.913 483.841C866.731 487.798 868.59 492.059 867.822 496.327 867.207 499.606 865.12 502.437 862.142 504.034 860.193 505.059 857.689 505.45 855.809 504.297 854.211 503.312 853.429 501.458 852.804 499.712 849.729 491.102 848.107 482.056 848.002 472.931 847.933 466.789 849.758 461.78 853.072 456.581 853.271 456.271 853.586 455.907 853.943 456.022 854.3 456.136 854.334 456.413 854.417 456.696 855.912 461.496 856.948 466.877 859.02 471.462 860.879 475.568 863.006 479.687 864.913 483.841Z",
    fill: "#FFFFFF",
    fillRule: "evenodd",
    fillOpacity: 0.329412
  }), /*#__PURE__*/React.createElement("path", {
    d: "M859.788 513.965C865.77 512.13 869.801 506.299 870.739 500.265 871.678 494.231 869.969 488.075 867.444 482.508 864.919 476.942 861.577 471.734 858.957 466.221 857.243 462.592 856.122 458.772 854.744 455 855.602 461.685 857.634 468.165 860.747 474.138 863.11 478.675 866.094 482.942 867.829 487.73 869.564 492.518 869.855 498.267 866.972 502.493 862.489 509.082 853.961 509.353 846.764 509.028 842.591 508.839 838.169 507.457 835.738 504.057 833.895 501.437 833.456 498.159 833.301 495.003 832.865 486.536 833.9 478.057 836.359 469.946 835.455 472.919 833.909 475.987 832.862 478.926 831.653 482.534 830.834 486.262 830.418 490.046 829.824 494.685 829.743 499.459 830.978 503.969 833.071 511.453 840.741 515.868 848.161 515.997 852.125 516.064 856.047 515.116 859.788 513.965Z",
    fill: "#FFFFFF",
    fillRule: "evenodd",
    fillOpacity: 0.388235
  }), /*#__PURE__*/React.createElement("path", {
    d: "M850.24 449.003C850.471 448.982 850.696 449.078 850.841 449.26 851.531 450.651 849.805 452.077 848.935 453.065 848.19 453.893 847.397 454.676 846.56 455.409 846.077 455.847 845.138 457.175 844.419 456.981 843.038 456.605 845.469 452.807 845.952 452.112 846.94 450.603 848.397 449.128 850.24 449.003Z",
    fill: "#FFFFFF",
    fillRule: "evenodd",
    fillOpacity: 0.901961
  }), /*#__PURE__*/React.createElement("path", {
    d: "M837.058 511.12C837.118 510.899 837.237 510.702 837.4 510.556 837.672 510.345 837.984 510.207 838.313 510.151 840.81 509.594 843.163 510.715 845.542 511.279 847.75 511.8 850.089 511.923 852.113 513.058 853.729 513.955 852.888 514.917 851.567 515.488 849.8 516.262 847.71 516.023 845.89 515.654 843.097 515.083 839.831 514.208 837.544 512.263 837.297 512.094 837.108 511.84 837.006 511.539 836.99 511.397 837.008 511.252 837.058 511.12Z",
    fill: "#FFFFFF",
    fillRule: "evenodd",
    fillOpacity: 0.411765
  }), /*#__PURE__*/React.createElement("path", {
    d: "M842.309 458.056C842.717 457.891 843.065 458.056 842.99 458.996 842.928 459.707 842.695 460.392 842.309 460.994 841.606 462.189 840.533 463.609 839.119 464 838.567 463.369 840.094 460.596 840.472 459.927 840.925 459.166 841.555 458.525 842.309 458.056Z",
    fill: "#FFFFFF",
    fillRule: "evenodd",
    fillOpacity: 0.901961
  }), /*#__PURE__*/React.createElement("path", {
    d: "M906.997 311.615 906.997 311.615 906.997 305.274 891.889 305.274 886.673 302.437C885.48 301.786 883.38 301.876 881.995 302.617L877.126 305.268 862 305.251 862 311.773C861.993 312.283 862.31 312.747 862.806 312.952L882.33 323.563C883.523 324.214 885.623 324.124 887.008 323.383L905.857 313.138C906.657 312.699 907.039 312.138 906.997 311.615Z",
    fill: "#00BAC6",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M885 302C884.105 302.014 883.226 302.226 882.438 302.617L877.461 305.266 862 305.261 862 311.776C861.992 312.286 862.317 312.75 862.823 312.955L882.78 323.557C883.465 323.881 884.231 324.032 885 323.994Z",
    fill: "#00BAC6",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M864 305 862 305 862 312.162C861.991 312.722 862.361 313.232 862.938 313.457L863.993 314Z",
    fill: "#11EEFF",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M883 323.692C883.971 324.116 885.037 324.102 886 323.651L886 316 883 316Z",
    fill: "#11EEFF",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M882.328 317.549 862.808 306.732C861.614 306.066 861.758 304.906 863.142 304.137L881.994 293.636C883.378 292.866 885.473 292.786 886.672 293.446L906.192 304.292C907.386 304.958 907.242 306.123 905.858 306.893L887.006 317.365C885.622 318.135 883.527 318.215 882.328 317.549Z",
    fill: "#D4ECFF",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M882.715 315.626 866.664 306.513C865.68 305.937 865.803 304.976 866.945 304.331L882.44 295.535C883.623 294.884 885.051 294.824 886.286 295.374L902.332 304.487C903.321 305.062 903.198 306.024 902.056 306.674L886.561 315.47C885.376 316.117 883.95 316.175 882.715 315.626Z",
    fill: "#11EEFF",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M906.997 301.6 906.997 301.6 906.997 295.25 891.889 295.25 886.673 292.438C885.48 291.786 883.38 291.876 881.995 292.618L877.126 295.267 862 295.267 862 301.757C861.993 302.268 862.31 302.733 862.806 302.938L882.33 313.562C883.523 314.215 885.623 314.125 887.008 313.382L905.857 303.124C906.657 302.668 907.039 302.106 906.997 301.6Z",
    fill: "#00BAC6",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M885 292C884.105 292.014 883.226 292.226 882.438 292.618L877.461 295.264 862 295.264 862 301.764C861.992 302.274 862.317 302.739 862.823 302.944L882.78 313.556C883.465 313.881 884.231 314.032 885 313.994Z",
    fill: "#00BAC6",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M864 295 862 295 862 302.162C861.991 302.722 862.361 303.232 862.938 303.457L863.993 304Z",
    fill: "#11EEFF",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M883 313.692C883.971 314.116 885.037 314.102 886 313.651L886 306 883 306Z",
    fill: "#11EEFF",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M882.328 307.54 862.808 296.699C861.614 296.034 861.758 294.874 863.142 294.105L881.994 283.638C883.378 282.869 885.473 282.783 886.672 283.448L906.192 294.289C907.386 294.955 907.242 296.12 905.858 296.889L887.006 307.356C885.622 308.125 883.527 308.229 882.328 307.54Z",
    fill: "#D4ECFF",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M882.715 305.626 866.664 296.513C865.68 295.937 865.803 294.976 866.945 294.331L882.44 285.535C883.623 284.883 885.051 284.824 886.286 285.374L902.332 294.487C903.321 295.062 903.198 296.024 902.056 296.668L886.561 305.47C885.376 306.117 883.95 306.175 882.715 305.626Z",
    fill: "#11EEFF",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M906.997 291.616 906.997 291.616 906.997 285.274 891.889 285.274 886.673 282.437C885.48 281.786 883.38 281.876 881.995 282.617L877.126 285.263 862 285.263 862 291.773C861.994 292.282 862.311 292.746 862.806 292.953L882.33 303.563C883.523 304.215 885.623 304.125 887.008 303.378L905.857 293.132C906.657 292.705 907.039 292.144 906.997 291.616Z",
    fill: "#00BAC6",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M885 282C884.104 282.011 883.225 282.223 882.438 282.617L877.461 285.262 862 285.262 862 291.773C861.994 292.282 862.318 292.746 862.823 292.952L882.78 303.556C883.465 303.881 884.231 304.032 885 303.994Z",
    fill: "#00BAC6",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M864 285 862 285 862 291.366C861.993 291.863 862.362 292.316 862.938 292.517L863.993 293Z",
    fill: "#11EEFF",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M883 303.693C883.972 304.118 885.038 304.101 886 303.646L886 296 883 296Z",
    fill: "#11EEFF",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M882.328 296.569 862.808 286.157C861.614 285.518 861.758 284.404 863.142 283.666L881.994 273.612C883.378 272.874 885.473 272.791 886.672 273.431L906.192 283.842C907.386 284.482 907.242 285.601 905.858 286.339L887.006 296.393C885.622 297.126 883.527 297.208 882.328 296.569Z",
    fill: "#11EEFF",
    fillRule: "evenodd",
    fillOpacity: 0.631373
  }), /*#__PURE__*/React.createElement("path", {
    d: "M905.857 285.752 887.005 295.262C885.621 295.961 883.526 296.04 882.327 295.434L862.807 285.569C862.571 285.454 862.368 285.296 862.21 285.104 861.798 285.684 861.989 286.311 862.807 286.729L882.327 296.593C883.52 297.199 885.621 297.116 887.005 296.426L905.857 286.901C906.931 286.379 907.26 285.595 906.794 285 906.559 285.315 906.237 285.574 905.857 285.752Z",
    fill: "#FFFFFF",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M900 313.551C899.962 314.097 899.591 314.596 899 314.894 898.447 315.141 898 314.941 898 314.449 898.037 313.903 898.409 313.404 899 313.106 899.553 312.859 900 313.059 900 313.551Z",
    fill: "#FFFFFF",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M902 312.543C901.981 313.089 901.797 313.59 901.502 313.896 901.226 314.139 901 313.942 901 313.449 901.024 312.91 901.21 312.419 901.502 312.119 901.762 311.852 902 312.05 902 312.543Z",
    fill: "#FFFFFF",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M905 310.557C904.964 311.101 904.592 311.598 904 311.895 903.447 312.14 903 311.942 903 311.451 903.038 310.907 903.409 310.41 904 310.113 904.553 309.85 905 310.066 905 310.557Z",
    fill: "#FFFFFF",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M900 303.551C899.962 304.097 899.591 304.596 899 304.894 898.447 305.141 898 304.941 898 304.449 898.036 303.903 898.408 303.403 899 303.106 899.553 302.859 900 303.059 900 303.551Z",
    fill: "#FFFFFF",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M902 301.555C901.977 302.097 901.793 302.592 901.502 302.895 901.226 303.141 901 302.942 901 302.445 901.02 301.9 901.207 301.402 901.502 301.105 901.762 300.859 902 301.058 902 301.555Z",
    fill: "#FFFFFF",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M905 300.549C904.962 301.096 904.591 301.595 904 301.894 903.447 302.141 903 301.941 903 301.448 903.036 300.901 903.408 300.401 904 300.103 904.553 299.862 905 300.056 905 300.549Z",
    fill: "#FFFFFF",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M900 293.541C899.962 294.09 899.591 294.593 899 294.894 898.447 295.142 898 294.941 898 294.445 898.036 293.895 898.408 293.392 899 293.092 899.553 292.867 900 293.068 900 293.541Z",
    fill: "#FFFFFF",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M902 291.556C901.98 292.099 901.795 292.594 901.502 292.892 901.226 293.144 901 292.939 901 292.447 901.02 291.901 901.207 291.403 901.502 291.105 901.762 290.859 902 291.058 902 291.556Z",
    fill: "#FFFFFF",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M905 290.542C904.962 291.091 904.591 291.593 904 291.894 903.447 292.142 903 291.941 903 291.445 903.036 290.896 903.408 290.393 904 290.093 904.553 289.875 905 290.046 905 290.542Z",
    fill: "#FFFFFF",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M883.482 290.786 874.377 285.58C873.818 285.262 873.889 284.702 874.532 284.331L883.334 279.307C884.003 278.931 884.814 278.898 885.512 279.219L894.623 284.425C895.182 284.743 895.111 285.303 894.468 285.668L885.672 290.697C884.997 291.067 884.186 291.1 883.482 290.786Z",
    fill: "#BFBFBF",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M884.375 285.982 883.059 285.545C882.977 285.52 882.984 285.474 883.059 285.442L884.307 285.023C884.406 284.992 884.525 284.992 884.625 285.023L885.942 285.456C886.023 285.485 886.016 285.531 885.942 285.563L884.706 285.975C884.603 286.006 884.482 286.008 884.375 285.982Z",
    fill: "#FFFFFF",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M874.376 286 874.376 286 874.507 285.906 883.322 280.561C883.992 280.161 884.804 280.126 885.503 280.467L894.604 285.988C895.117 285.599 895.147 285.073 894.604 284.734L885.527 279.233C884.828 278.892 884.016 278.927 883.346 279.327L874.555 284.672C873.887 285.066 873.816 285.662 874.376 286Z",
    fill: "#A6A6A6",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M881 298.727C881 298.972 880.779 299.071 880.508 298.946 880.21 298.797 880.02 298.546 880 298.271 880 298.03 880.221 297.931 880.492 298.051 880.791 298.2 880.98 298.451 881 298.727Z",
    fill: "#FFFFFF",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M880 297.726C880 297.97 879.775 298.07 879.5 297.948 879.207 297.797 879.022 297.549 879 297.277 879 297.029 879.225 296.928 879.5 297.055 879.793 297.205 879.978 297.454 880 297.726Z",
    fill: "#FFFFFF",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M881 300.723C881 300.971 880.775 301.072 880.5 300.945 880.207 300.795 880.022 300.546 880 300.274 880 300.03 880.225 299.93 880.5 300.052 880.793 300.203 880.978 300.451 881 300.723Z",
    fill: "#FFFFFF",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M880 299.726C880 299.97 879.775 300.07 879.5 299.948 879.207 299.797 879.022 299.549 879 299.277 879 299.029 879.225 298.928 879.5 299.055 879.793 299.205 879.978 299.454 880 299.726Z",
    fill: "#FFFFFF",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M881 308.719C881 308.971 880.779 309.073 880.508 308.945 880.218 308.798 880.031 308.551 880 308.278 880 308.031 880.221 307.929 880.492 308.053 880.782 308.2 880.969 308.446 881 308.719Z",
    fill: "#FFFFFF",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M880 307.723C880 307.971 879.775 308.072 879.5 307.945 879.207 307.795 879.022 307.547 879 307.275 879 307.027 879.225 306.931 879.5 307.053 879.793 307.203 879.978 307.451 880 307.723Z",
    fill: "#FFFFFF",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M881 310.723C881 310.971 880.775 311.072 880.5 310.945 880.207 310.795 880.022 310.546 880 310.274 880 310.03 880.225 309.93 880.5 310.052 880.793 310.203 880.978 310.451 881 310.723Z",
    fill: "#FFFFFF",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M880 309.724C880 309.972 879.775 310.072 879.5 309.945 879.207 309.795 879.022 309.548 879 309.276 879 309.028 879.225 308.929 879.5 309.055 879.793 309.205 879.978 309.452 880 309.724Z",
    fill: "#FFFFFF",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M881 318.722C881 318.97 880.775 319.07 880.5 318.948 880.207 318.798 880.022 318.55 880 318.278 880 318.03 880.225 317.93 880.5 318.052 880.793 318.202 880.978 318.45 881 318.722Z",
    fill: "#FFFFFF",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M880 317.723C880 317.971 879.775 318.072 879.5 317.945 879.207 317.795 879.022 317.546 879 317.274 879 317.03 879.225 316.93 879.5 317.052 879.793 317.203 879.978 317.451 880 317.723Z",
    fill: "#FFFFFF",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M881 320.722C881 320.97 880.775 321.07 880.5 320.948 880.207 320.798 880.022 320.55 880 320.278 880 320.03 880.225 319.93 880.5 320.052 880.793 320.202 880.978 320.45 881 320.722Z",
    fill: "#FFFFFF",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M880 319.723C880 319.971 879.775 320.072 879.5 319.945 879.207 319.795 879.022 319.546 879 319.274 879 319.03 879.225 318.93 879.5 319.052 879.793 319.203 879.978 319.451 880 319.723Z",
    fill: "#FFFFFF",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M984 365.946 983.385 365.946C983.038 365.517 982.612 365.159 982.131 364.892L901.062 319.073C898.326 317.484 893.547 317.683 890.409 319.515L883.629 323.644C882.88 324.047 882.221 324.599 881.692 325.266L881 325.266 881 346.68 881 346.68C881.087 347.598 881.683 348.467 882.826 349.108L963.913 394.927C966.649 396.516 971.429 396.317 974.567 394.485L981.346 390.356C982.847 389.487 983.705 388.413 983.908 387.344L983.961 387.344Z",
    fill: "url(#fill23)",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M963.935 373.936 882.847 328.678C880.11 327.114 880.454 324.36 883.617 322.575L890.396 318.492C893.553 316.689 898.333 316.492 901.05 318.056L982.153 363.328C984.889 364.892 984.545 367.646 981.388 369.436L974.608 373.514C971.451 375.323 966.671 375.5 963.935 373.936Z",
    fill: "#BFBFBF",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M981.413 369.63 974.632 373.768C971.473 375.596 966.692 375.796 963.974 374.211L882.84 328.344C881.745 327.707 881.149 326.885 881.028 326 880.859 327.138 881.45 328.256 882.84 329.064L963.955 374.93C966.692 376.516 971.473 376.316 974.612 374.483L981.394 370.349C983.288 369.255 984.16 367.821 983.976 366.508 983.831 367.607 982.964 368.735 981.413 369.63Z",
    fill: "#FFFFFF",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M969.762 373.998C968.61 374.025 967.472 373.753 966.459 373.211L931.177 352.932 895.896 332.652C894.76 332.074 894.033 330.93 894 329.668 894 328.345 894.831 327.109 896.282 326.288L896.932 321.006C898.16 320.336 899.542 319.99 900.945 320.002 902.094 319.976 903.232 320.245 904.244 320.784L942.174 342.208 980.104 363.641C981.241 364.216 981.968 365.359 982 366.62 982 367.948 981.169 369.179 979.718 370L973.775 372.999C972.546 373.667 971.164 374.011 969.762 373.998Z",
    fill: "#7F7F7F",
    fillRule: "evenodd",
    fillOpacity: 0.0117647
  }), /*#__PURE__*/React.createElement("path", {
    d: "M897.621 321.059C898.813 320.403 900.142 320.042 901.498 320.007 902.621 319.955 903.737 320.203 904.735 320.727 904.773 320.727 906.88 321.935 906.909 321.95L941.91 342.22 944.57 343.759 979.075 363.727C980.165 364.307 980.889 365.408 980.999 366.649 981.028 367.959 980.273 369.206 978.84 370.058L975.708 371.699C975.675 371.699 973.073 373.053 973.034 373.058 971.838 373.704 970.498 374.028 969.143 373.998 968.021 373.999 966.917 373.716 965.93 373.175L931.42 352.881 929.15 351.537 896.924 332.567C895.821 332.003 895.09 330.894 895 329.645 895.007 328.248 895.77 326.967 896.986 326.309L897.049 325.525C897.02 325.471 897.544 321.102 897.621 321.059Z",
    fill: "#7F7F7F",
    fillRule: "evenodd",
    fillOpacity: 0.0117647
  }), /*#__PURE__*/React.createElement("path", {
    d: "M897.288 321.11C898.476 320.47 899.786 320.096 901.129 320.016 902.25 319.936 903.372 320.161 904.379 320.669 904.456 320.669 906.517 321.832 906.571 321.866L941.708 342.209 944.38 343.756 979.017 363.814C980.099 364.403 980.835 365.482 980.996 366.715 981.059 368.016 980.361 369.273 978.911 370.122L975.787 371.781C975.719 371.82 973.183 373.107 973.101 373.116 971.903 373.741 970.567 374.043 969.221 373.995 968.099 373.972 967 373.675 966.015 373.131L931.489 352.803 929.205 351.473 896.944 332.475C895.862 331.846 895.004 330.693 895.004 329.578 894.942 328.24 895.613 326.976 896.75 326.289L896.779 325.523C896.629 325.455 897.143 321.194 897.288 321.11Z",
    fill: "#7F7F7F",
    fillRule: "evenodd",
    fillOpacity: 0.0117647
  }), /*#__PURE__*/React.createElement("path", {
    d: "M897.023 322.142C898.204 321.532 899.493 321.152 900.819 321.025 901.937 320.926 903.061 321.124 904.077 321.598 904.2 321.598 906.203 322.701 906.291 322.749L941.53 342.8 944.208 344.326 978.949 364.095C979.98 364.688 980.903 365.868 980.991 366.908 981.084 368.171 980.444 369.415 978.983 370.255L975.861 371.902C975.764 371.966 973.296 373.185 973.169 373.195 971.981 373.779 970.663 374.053 969.339 373.991 968.219 373.946 967.125 373.641 966.144 373.102L931.583 353.129 929.297 351.813 897.018 333.161C895.987 332.568 895 331.402 895 330.363 895 329.216 895.254 327.89 896.495 327.18L896.495 326.442C896.3 326.33 896.798 322.268 897.023 322.142Z",
    fill: "#7F7F7F",
    fillRule: "evenodd",
    fillOpacity: 0.0117647
  }), /*#__PURE__*/React.createElement("path", {
    d: "M897.693 322.184C898.841 321.596 900.082 321.211 901.361 321.045 902.449 320.911 903.553 321.078 904.554 321.526 904.713 321.526 906.622 322.564 906.732 322.627L941.261 342.39 943.886 343.89 977.924 363.37C978.886 363.923 979.886 365.125 979.982 366.091 980.112 367.322 979.54 368.553 978.097 369.389L975.058 371.024C974.924 371.101 972.587 372.255 972.423 372.269 971.265 372.818 969.986 373.065 968.707 372.985 967.617 372.914 966.556 372.604 965.6 372.077L931.812 352.472 929.581 351.174 898.034 332.852C897.072 332.299 896 331.121 896 330.15 896 329.083 896.062 327.747 897.216 327.074L897.183 326.367C896.933 326.223 897.404 322.377 897.693 322.184Z",
    fill: "#7F7F7F",
    fillRule: "evenodd",
    fillOpacity: 0.0117647
  }), /*#__PURE__*/React.createElement("path", {
    d: "M897.434 322.247C898.575 321.669 899.796 321.269 901.057 321.059 902.143 320.905 903.251 321.053 904.259 321.486 905.012 321.803 905.747 322.164 906.458 322.566L941.089 342.402 943.695 343.895 977.845 363.469C978.756 363.992 979.851 365.233 979.972 366.149 980.132 367.375 979.623 368.606 978.16 369.449L975.133 371.106C974.963 371.203 972.711 372.313 972.488 372.328 971.335 372.853 970.069 373.076 968.806 372.977 967.72 372.883 966.665 372.56 965.711 372.032L931.904 352.395 929.671 351.101 898.093 332.748C897.182 332.22 896.005 331.009 896.005 330.088 896.005 329.075 895.874 327.694 896.974 327.064L896.906 326.371C896.586 326.206 897.041 322.455 897.434 322.247Z",
    fill: "#7F7F7F",
    fillRule: "evenodd",
    fillOpacity: 0.0117647
  }), /*#__PURE__*/React.createElement("path", {
    d: "M897.134 323.284C898.271 322.733 899.475 322.329 900.717 322.081 901.802 321.901 902.916 322.022 903.934 322.431 904.696 322.723 905.437 323.067 906.15 323.461L940.884 342.999 943.529 344.484 977.77 363.739C978.629 364.218 979.82 365.483 979.957 366.327 980.152 367.53 979.703 368.723 978.224 369.576L975.232 371.215C974.37 371.657 973.484 372.051 972.577 372.394 971.429 372.885 970.173 373.083 968.926 372.969 967.844 372.854 966.797 372.528 965.846 372.01L932.015 352.736 929.779 351.462 898.194 333.467C897.334 332.988 896.046 331.761 896.046 330.903 896.046 329.945 895.729 328.574 896.763 327.985L896.661 327.324C896.251 327.094 896.695 323.538 897.134 323.284Z",
    fill: "#7F7F7F",
    fillRule: "evenodd",
    fillOpacity: 0.0117647
  }), /*#__PURE__*/React.createElement("path", {
    d: "M896.951 323.357C898.078 322.811 899.263 322.391 900.484 322.105 901.561 321.899 902.675 321.997 903.698 322.386 904.467 322.661 905.212 322.998 905.926 323.391L940.692 343.007 943.337 344.5 977.602 363.826C978.412 364.285 979.855 365.57 979.855 366.372 980.306 367.513 979.693 368.788 978.201 369.629L975.203 371.296C974.344 371.739 973.455 372.124 972.543 372.45 971.403 372.914 970.163 373.089 968.937 372.958 968.093 372.958 966.483 372.291 965.87 371.948L932.1 352.66 929.867 351.385 898.34 333.377C897.53 332.894 896.136 331.667 896.136 330.86 896.136 329.976 895.621 328.546 896.593 327.995L896.455 327.348C896.004 327.092 896.431 323.651 896.951 323.357Z",
    fill: "#7F7F7F",
    fillRule: "evenodd",
    fillOpacity: 0.0117647
  }), /*#__PURE__*/React.createElement("path", {
    d: "M897.744 323.432C898.836 322.896 899.975 322.462 901.146 322.136 902.192 321.9 903.283 321.972 904.289 322.346 905.05 322.598 905.784 322.924 906.482 323.32L940.472 343.01 943.061 344.511 976.569 363.923C977.302 364.352 978.83 365.672 978.83 366.427 979.312 367.548 978.762 368.834 977.292 369.691L974.4 371.372C973.563 371.814 972.695 372.192 971.802 372.502 970.695 372.945 969.494 373.096 968.312 372.94 967.546 372.94 965.903 372.215 965.339 371.893L932.394 352.597 930.216 351.321 899.464 333.297C898.727 332.868 897.262 331.577 897.262 330.822 897.262 330.067 896.563 328.523 897.45 328.006L897.281 327.378C896.76 327.081 897.16 323.773 897.744 323.432Z",
    fill: "#7F7F7F",
    fillRule: "evenodd",
    fillOpacity: 0.0117647
  }), /*#__PURE__*/React.createElement("path", {
    d: "M897.753 323.512C898.833 322.98 899.95 322.532 901.096 322.171 902.133 321.903 903.225 321.951 904.236 322.309 904.594 322.309 906.171 323.109 906.437 323.257L940.401 343.035 942.984 344.537 976.46 364.021C977.142 364.419 978.777 365.779 978.777 366.476 979.348 367.581 978.806 368.882 977.326 369.751L974.424 371.445C973.593 371.894 972.726 372.267 971.831 372.56 970.731 372.973 969.546 373.098 968.386 372.923 967.675 372.923 965.968 372.138 965.44 371.838L932.613 352.526 930.441 351.25 899.804 333.214C899.122 332.817 897.55 331.491 897.55 330.789 897.55 330.087 896.66 328.51 897.482 328.029L897.279 327.415C896.704 327.086 897.095 323.885 897.753 323.512Z",
    fill: "#7F7F7F",
    fillRule: "evenodd",
    fillOpacity: 0.0117647
  }), /*#__PURE__*/React.createElement("path", {
    d: "M897.783 324.562C898.85 324.047 899.946 323.593 901.065 323.203 902.093 322.912 903.185 322.934 904.201 323.266 904.972 323.479 905.715 323.784 906.414 324.174L940.336 343.632 942.918 345.088 976.359 364.274C976.985 364.638 978.732 366.012 978.732 366.648 979.368 367.712 978.854 369.003 977.368 369.862L974.495 371.547C973.667 371.984 972.799 372.342 971.903 372.615 970.812 372.996 969.644 373.096 968.505 372.906 967.849 372.906 966.048 372.066 965.592 371.799L932.884 352.866 930.719 351.608 900.186 333.922C899.56 333.563 897.885 332.233 897.885 331.592 897.885 330.951 896.803 329.374 897.555 328.937L897.322 328.354C896.701 327.961 897.045 324.97 897.783 324.562Z",
    fill: "#7F7F7F",
    fillRule: "evenodd",
    fillOpacity: 0.0117647
  }), /*#__PURE__*/React.createElement("path", {
    d: "M897.824 324.645C898.358 324.332 900.373 323.485 901.008 323.24 902.017 322.92 903.097 322.92 904.106 323.24 904.538 323.24 905.986 323.935 906.294 324.116L939.756 343.645 942.3 345.113 975.281 364.368C975.843 364.701 977.686 366.11 977.686 366.692 978.383 367.74 977.902 369.046 976.425 369.917L973.612 371.62C972.798 372.059 971.94 372.409 971.053 372.662 969.987 373.019 968.85 373.095 967.749 372.882 967.157 372.882 965.31 371.982 964.863 371.732L932.69 352.781 930.559 351.528 900.546 333.849C899.979 333.516 898.218 332.151 898.218 331.569 898.218 330.986 896.958 329.362 897.636 328.965L897.372 328.398C896.679 327.992 897.026 325.115 897.824 324.645Z",
    fill: "#7F7F7F",
    fillRule: "evenodd",
    fillOpacity: 0.0117647
  }), /*#__PURE__*/React.createElement("path", {
    d: "M897.873 324.705C898.355 324.425 900.435 323.522 900.995 323.28 901.993 322.937 903.073 322.909 904.088 323.198 904.857 323.368 905.598 323.649 906.288 324.029L939.69 343.231 942.233 344.68 975.176 363.63C975.687 363.925 977.637 365.345 977.637 365.867 978.394 366.872 977.95 368.166 976.459 369.026L973.67 370.712C972.862 371.145 972.005 371.481 971.118 371.712 970.06 372.039 968.938 372.088 967.856 371.857 967.325 371.857 965.404 370.915 965.023 370.693L932.973 352.129 930.854 350.897 900.937 333.569C900.425 333.275 898.563 331.903 898.563 331.386 898.563 330.869 897.115 329.246 897.718 328.888L897.419 328.352C896.666 327.884 896.994 325.212 897.873 324.705Z",
    fill: "#7F7F7F",
    fillRule: "evenodd",
    fillOpacity: 0.0117647
  }), /*#__PURE__*/React.createElement("path", {
    d: "M897.913 325.755C898.344 325.511 900.484 324.547 900.977 324.322 901.965 323.953 903.046 323.9 904.066 324.17 904.841 324.317 905.587 324.583 906.278 324.957L939.642 343.829 942.178 345.261 975.067 363.879C975.522 364.137 977.584 365.569 977.584 366.023 978.407 366.978 977.991 368.276 976.49 369.131L973.726 370.802C972.921 371.227 972.063 371.547 971.175 371.756 970.129 372.053 969.024 372.079 967.965 371.833 967.481 371.833 965.497 370.84 965.158 370.649L933.237 352.47 931.126 351.267 901.336 334.281C900.881 334.018 898.915 332.639 898.915 332.185 898.915 331.732 897.265 330.104 897.812 329.798L897.478 329.287C896.65 328.81 896.964 326.299 897.913 325.755Z",
    fill: "#7F7F7F",
    fillRule: "evenodd",
    fillOpacity: 0.0117647
  }), /*#__PURE__*/React.createElement("path", {
    d: "M897.962 325.846C898.336 325.63 900.54 324.582 900.968 324.361 901.886 323.88 903.061 323.961 904.047 324.139 904.825 324.263 905.575 324.519 906.266 324.894L939.579 343.846 942.114 345.289 974.957 363.967C975.36 364.193 977.531 365.665 977.531 366.064 978.424 367.026 978.016 368.315 976.525 369.175L973.786 370.868C972.984 371.293 972.126 371.605 971.237 371.796 970.201 372.068 969.111 372.068 968.076 371.796 967.658 371.796 965.594 370.743 965.298 370.57L933.509 352.378 931.406 351.171 901.745 334.19C901.342 333.959 899.268 332.545 899.268 332.146 899.268 331.747 897.423 330.088 897.903 329.814L897.534 329.333C896.636 328.794 896.932 326.433 897.962 325.846Z",
    fill: "#7F7F7F",
    fillRule: "evenodd",
    fillOpacity: 0.0117647
  }), /*#__PURE__*/React.createElement("path", {
    d: "M898.004 325.939C898.326 325.75 900.559 324.611 900.891 324.408 901.772 323.894 902.941 323.957 903.927 324.107 904.7 324.214 905.447 324.462 906.131 324.839L938.986 343.851 941.488 345.305 973.871 364.046C974.207 364.245 976.469 365.752 976.469 366.101 977.431 367.032 977.061 368.345 975.56 369.217L972.875 370.923C972.089 371.354 971.242 371.66 970.363 371.83 969.351 372.078 968.293 372.055 967.293 371.762 966.937 371.762 964.825 370.647 964.57 370.497L933.293 352.303 931.224 351.097 902.051 334.134C901.709 333.94 899.558 332.491 899.558 332.142 899.558 331.794 897.537 330.102 897.946 329.865L897.547 329.38C896.637 328.818 896.912 326.574 898.004 325.939Z",
    fill: "#7F7F7F",
    fillRule: "evenodd",
    fillOpacity: 0.0117647
  }), /*#__PURE__*/React.createElement("path", {
    d: "M898.043 326.005C898.308 325.849 900.547 324.427 900.889 324.427 901.854 324.047 902.897 323.918 903.924 324.051 904.697 324.135 905.446 324.373 906.129 324.75L938.937 343.838 941.436 345.304 973.762 364.123C974.047 364.284 976.416 365.838 976.416 366.126 977.429 367.04 977.105 368.37 975.595 369.249L972.937 370.979C972.155 371.408 971.309 371.705 970.433 371.859 969.43 372.087 968.385 372.038 967.408 371.717 967.113 371.717 964.928 370.534 964.716 370.412L933.572 352.199 931.512 350.997 902.477 334.015C902.197 333.849 899.934 332.363 899.934 332.06 899.934 331.757 897.719 330.037 898.062 329.842L897.628 329.382C896.619 328.801 896.875 326.685 898.043 326.005Z",
    fill: "#7F7F7F",
    fillRule: "evenodd",
    fillOpacity: 0.0117647
  }), /*#__PURE__*/React.createElement("path", {
    d: "M898.098 327.065C898.316 326.945 900.616 325.475 900.887 325.475 901.845 325.081 902.885 324.928 903.917 325.031 904.693 325.098 905.448 325.32 906.134 325.687L938.877 344.434 941.37 345.88 973.644 364.357C973.871 364.487 976.355 366.044 976.355 366.285 977.434 367.157 977.139 368.473 975.624 369.345L972.985 371.056C972.206 371.476 971.359 371.759 970.483 371.894 969.489 372.088 968.462 372.015 967.506 371.682 966.593 371.295 965.704 370.854 964.843 370.362L933.862 352.53 931.81 351.35 902.891 334.752C902.668 334.622 900.301 333.133 900.301 332.901 900.301 332.67 897.88 330.945 898.161 330.786L897.677 330.357C896.617 329.716 896.835 327.783 898.098 327.065Z",
    fill: "#7F7F7F",
    fillRule: "evenodd",
    fillOpacity: 0.0117647
  }), /*#__PURE__*/React.createElement("path", {
    d: "M898.117 327.175C898.275 327.083 900.606 325.539 900.808 325.539 901.745 325.116 902.773 324.938 903.796 325.019 904.565 325.063 905.314 325.277 905.992 325.646L938.28 344.449 940.74 345.906 972.563 364.442C972.731 364.544 975.302 366.137 975.302 366.312 976.429 367.161 976.174 368.497 974.664 369.381L972.083 371.105C971.316 371.528 970.479 371.805 969.613 371.921 968.646 372.088 967.652 371.99 966.736 371.634 966.558 371.634 964.256 370.347 964.131 370.27L933.661 352.471 931.642 351.296 903.215 334.688C903.047 334.591 900.601 333.066 900.601 332.891 900.601 332.716 898.026 330.949 898.203 330.837L897.724 330.424C896.592 329.74 896.836 327.938 898.117 327.175Z",
    fill: "#7F7F7F",
    fillRule: "evenodd",
    fillOpacity: 0.0117647
  }), /*#__PURE__*/React.createElement("path", {
    d: "M898.178 327.296C898.284 327.232 900.671 325.607 900.805 325.607 901.734 325.156 902.761 324.951 903.789 325.01 904.56 325.035 905.315 325.239 905.997 325.607L938.235 344.48 940.689 345.914 972.446 364.513C972.557 364.577 975.237 366.217 975.237 366.334 976.435 367.161 976.2 368.512 974.689 369.403L972.134 371.15C971.369 371.574 970.531 371.842 969.665 371.938 968.704 372.089 967.721 371.963 966.826 371.576 966.711 371.576 964.334 370.22 964.247 370.171L933.934 352.38 931.922 351.2 903.601 334.608C903.49 334.539 900.94 332.978 900.94 332.866 900.94 332.753 898.183 330.962 898.308 330.864L897.779 330.472C896.59 329.767 896.792 328.108 898.178 327.296Z",
    fill: "#7F7F7F",
    fillRule: "evenodd",
    fillOpacity: 0.0117647
  }), /*#__PURE__*/React.createElement("path", {
    d: "M897.238 327.411C897.292 327.381 899.769 325.68 899.837 325.68 900.769 325.2 901.807 324.967 902.852 325.004 903.633 325.008 904.403 325.2 905.095 325.566L937.677 344.5 940.159 345.94 972.273 364.603C972.331 364.638 975.16 366.315 975.16 366.374 976.441 367.183 976.24 368.549 974.672 369.452L972.107 371.193C971.339 371.62 970.492 371.881 969.619 371.957 968.654 372.083 967.674 371.931 966.79 371.518 966.732 371.518 964.254 370.098 964.21 370.073L933.636 352.288 931.613 351.109 903.111 334.542C903.057 334.508 900.365 332.915 900.365 332.856 900.365 332.796 897.355 330.957 897.433 330.917L896.862 330.543C895.571 329.798 895.757 328.284 897.238 327.411Z",
    fill: "#7F7F7F",
    fillRule: "evenodd",
    fillOpacity: 0.0117647
  }), /*#__PURE__*/React.createElement("path", {
    d: "M966.914 371.479 931.913 351.484 896.913 331.489C895.56 330.716 895.732 329.37 897.29 328.475L899.829 326.73C901.383 325.84 903.75 325.758 905.088 326.516L940.089 346.511 975.089 366.501C976.437 367.274 976.27 368.625 974.712 369.515L972.173 371.275C970.619 372.155 968.262 372.247 966.914 371.479Z",
    fill: "#7F7F7F",
    fillRule: "evenodd",
    fillOpacity: 0.0117647
  }), /*#__PURE__*/React.createElement("path", {
    d: "M966.99 370.17 899.006 331.505C895.136 329.298 892 323.374 892 318.275L892 261.064C892 255.966 895.136 253.624 899.006 255.83L966.99 294.496C970.859 296.707 974 302.631 974 307.73L974 364.936C974 370.034 970.859 372.376 966.99 370.17Z",
    fill: "#F2F2F2",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M968.781 368.728 900.15 329.163C896.967 327.139 895 323.086 895 318.946L895 259.283C894.994 258.581 895.557 258.006 896.258 258 896.498 257.998 896.734 258.064 896.938 258.191L897.161 258.322 965.85 297.94C969.639 300.129 971 304.017 971 308.157L971 367.631C970.998 368.389 970.382 369.002 969.625 369 969.388 368.999 969.156 368.937 968.951 368.82Z",
    fill: "#560F54",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M965.852 297.94 897.16 258.322 896.937 258.191C896.342 257.821 895.559 258.005 895.19 258.602 895.064 258.806 894.998 259.042 895 259.283L895 318.946C895 323.086 896.966 327.139 900.148 329.163L968.782 368.728 968.951 368.82C969.609 369.195 970.446 368.965 970.82 368.306 970.938 368.1 970.999 367.868 971 367.631L971 308.157C971 304.017 969.639 300.129 965.852 297.94ZM970.211 367.631C970.208 367.943 969.956 368.196 969.644 368.199 969.545 368.199 969.448 368.172 969.363 368.121L900.594 328.464C897.722 326.634 895.848 322.892 895.848 318.946L895.848 259.283C895.867 259.016 896.098 258.814 896.365 258.834 896.43 258.838 896.492 258.856 896.55 258.885L965.45 298.639C969.373 300.906 970.196 305.065 970.196 308.157Z",
    fill: "#A6A6A6",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M970.043 292.604 902.525 253.833C901.006 252.956 899.614 252.796 898.454 253.237 898.309 253.295 895.136 255.13 895 255.208L895 255.208C896.189 254.631 897.693 254.723 899.332 255.692L966.836 294.459C970.679 296.676 973.798 302.617 973.798 307.73L973.798 365.093C973.798 368.284 972.58 370.419 970.737 371 970.956 370.987 971.167 370.915 971.348 370.792 971.435 370.739 974.768 368.744 974.856 368.686 976.175 367.761 977 365.863 977 363.239L977 305.87C977 300.758 973.885 294.822 970.043 292.604Z",
    fill: "#D9D9D9",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M967.092 294.507 900.156 255.824C898.593 254.915 897.155 254.79 896 255.292 897.167 255.159 898.342 255.436 899.329 256.075L966.274 294.758C970.084 296.966 973.173 302.893 973.173 307.994L973.173 365.227C973.173 368.237 972.095 370.275 970.431 371 972.557 370.657 974 368.464 974 364.976L974 307.743C974 302.642 970.912 296.715 967.092 294.507Z",
    fill: "#F2F2F2",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M897.857 262C897.857 262.545 897.828 336.454 897.823 343.578 897.823 347.471 897.823 354.006 897.823 354.055 897.823 356.659 896.163 359.773 894 361.408 897.707 363.559 946.693 391.579 953.037 395.268L958.588 395.268 958.588 399.808C958.539 401.306 959.554 402.629 961.008 402.961L961.008 402.961C961.109 402.961 961.211 402.99 961.312 403L961.704 403C962.344 402.933 962.961 402.724 963.509 402.387 964.225 401.958 964.869 401.418 965.416 400.786 966.128 400.115 966.68 399.292 967.032 398.377 967.634 397.201 967.965 395.904 968 394.581 968 394.557 968 394.095 968 392.878 968 392.576 968 302.517 968 302.215Z",
    fill: "#F2F2F2",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M897.034 266.804 968 306.358C968 303.624 968 300.254 968 301.571L897.034 262.012C897.034 261.146 897.005 306.721 897 313.71 897 315.534 897 317.956 897 320 897.005 308.89 897.034 269.647 897.034 266.804Z",
    fill: "#26A1AA",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M949 368C949.3 368.39 949.636 368.726 950 369L950 368.761C949.386 368.289 949 367.994 949 368Z",
    fill: "#E6E7E8",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M924 331 924 329.687 914 324 914 325.308 924 331Z",
    fill: "#8D97D6",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M927 345 927 343.692 918 338 918 339.308 927 345Z",
    fill: "#8D97D6",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M902 322 902 323.192 930 339 930 337.808 902 322Z",
    fill: "#8D97D6",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M921 337.788 902 327 902 328.212 921 339 921 337.788Z",
    fill: "#8D97D6",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M913 330.661 902 324 902 325.344 913 332 913 330.661Z",
    fill: "#8D97D6",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M914 331 914 332.226 945 350 945 348.774 914 331Z",
    fill: "#8D97D6",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M922.171 338.776 932.2 344.561 932.2 345.784 922.171 339.995ZM942.585 335.648 951.467 340.726 951.467 341.949 942.585 336.871ZM933.796 333.304 959.514 347.782 959.514 349 933.796 334.522ZM924.92 330.668 934.519 336.135 934.519 337.354 924.92 331.886ZM942.253 327.466 958.405 336.584 958.405 337.807 942.253 328.689ZM945.813 327.091 962.976 336.671 962.976 337.89 945.813 328.309ZM918.684 324.659 932.595 332.607 932.595 333.83 918.684 325.878ZM930.227 320.62 941.052 326.774 941.052 327.993 930.227 321.843ZM934.578 320.61 944.607 326.399 944.607 327.617 934.578 321.828ZM913.885 319.358 941.379 334.956 941.379 336.174 913.885 320.576ZM902 317.579 913.133 323.977 913.133 325.2 902 318.797ZM921.448 315.567 929.026 319.928 929.026 321.146 921.448 316.785ZM942.253 315.323 958.405 324.435 958.405 325.658 942.253 316.541ZM902 315.06 917.483 323.968 917.483 325.186 902 316.278ZM945.813 314.943 962.976 324.523 962.976 325.741 945.813 316.161ZM926.087 313.242 957.273 330.907 957.273 332.125 926.087 314.46ZM921.448 313.047 933.376 319.918 933.376 321.136 921.448 314.265ZM902 312.526 912.683 318.666 912.683 319.884 902 313.744ZM921.448 310.513 924.88 312.55 924.88 313.768 921.448 311.731ZM902 310.08 926.917 324.25 926.917 325.468 902 311.298ZM930.227 308.476 941.052 314.626 941.052 315.849 930.227 309.695ZM934.578 308.462 944.607 314.251 944.607 315.469 934.578 309.68ZM921.448 308.067 942.81 320.196 942.81 321.419 921.448 309.285ZM921.448 303.418 929.026 307.78 929.026 308.998 921.448 304.636ZM946.067 301.557 963 311.156 963 312.375 946.067 302.775ZM926.087 301.094 957.273 318.758 957.273 319.977 926.087 302.312ZM921.448 300.899 933.376 307.77 933.376 308.988 921.448 302.117ZM937.283 299.208 954.953 309.168 954.953 310.387 937.283 300.431ZM921.448 298.365 924.88 300.402 924.88 301.62 921.448 299.583ZM921.448 295.919 942.81 308.048 942.81 309.271 921.448 297.137ZM922.171 290.568 936.077 298.516 936.077 299.734 922.171 291.786ZM917.371 285.266 944.866 300.865 944.866 302.083 917.371 286.485ZM902 278.98 920.965 289.871 920.965 291.094 902 280.203ZM902 276.446 916.165 284.574 916.165 285.793 902 277.669ZM902 274 930.398 290.154 930.398 291.372 902 275.223Z",
    fill: "#560F54",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M933 346.197 948 354 948 352.803 933 345 933 346.197Z",
    fill: "#8D97D6",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M917 337.732 902 329 902 330.273 917 339 917 337.732Z",
    fill: "#8D97D6",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M928 345.281 938 351 938 349.724 928 344 928 345.281Z",
    fill: "#8D97D6",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M946 350.239 963 360 963 358.761 946 349 946 350.239Z",
    fill: "#560F54",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M946 371.241 963 381 963 379.759 946 370 946 371.241Z",
    fill: "#560F54",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M946 360.241 963 370 963 368.759 946 359 946 360.241Z",
    fill: "#560F54",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M897.385 313.875C893.855 311.844 891 313.469 891 317.506L891 356.566C891 360.603 893.855 365.52 897.385 367.55L959.841 402.486C963.366 404.517 961.514 400.141 961.514 396.109L961.514 357.049C961.514 353.012 957.243 348.318 953.718 346.287Z",
    fill: "#BFBFBF",
    fillRule: "evenodd",
    fillOpacity: 0.0784314
  }), /*#__PURE__*/React.createElement("path", {
    d: "M897.416 313.871C893.869 311.85 891 313.466 891 317.479L891 352.791C891 356.803 893.869 364.977 897.416 366.993L959.601 401.468C963.148 403.488 961.713 399.385 961.713 395.377L961.713 360.06C961.713 356.048 957.547 348.081 954 346.06Z",
    fill: "#BFBFBF",
    fillRule: "evenodd",
    fillOpacity: 0.0784314
  }), /*#__PURE__*/React.createElement("path", {
    d: "M897.356 313.871C893.844 311.847 891 313.469 891 317.498L891 349.454C891 353.482 893.844 365.006 897.356 367.035L958.357 401.446C961.869 403.47 960.868 399.596 960.868 395.568L960.868 363.612C960.868 359.583 956.867 348.239 953.36 346.21Z",
    fill: "#BFBFBF",
    fillRule: "evenodd",
    fillOpacity: 0.0784314
  }), /*#__PURE__*/React.createElement("path", {
    d: "M897.38 313.876C893.855 311.841 891 313.472 891 317.52L891 346.08C891 350.132 893.855 365.04 897.38 367.076L958.043 401.418C961.564 403.454 960.961 399.81 960.961 395.758L960.961 367.179C960.961 363.131 957.07 348.384 953.549 346.348Z",
    fill: "#BFBFBF",
    fillRule: "evenodd",
    fillOpacity: 0.0784314
  }), /*#__PURE__*/React.createElement("path", {
    d: "M897.303 313.873C893.82 311.847 891 313.466 891 317.494L891 342.335C891 346.363 893.82 364.506 897.303 366.532L956.665 400.394C960.148 402.42 959.999 399.046 959.999 395.018L959.999 370.177C959.999 366.149 956.28 348.147 952.782 346.126Z",
    fill: "#BFBFBF",
    fillRule: "evenodd",
    fillOpacity: 0.0784314
  }), /*#__PURE__*/React.createElement("path", {
    d: "M897.321 313.876C893.83 311.842 891 313.471 891 317.515L891 338.918C891 342.961 893.83 364.544 897.321 366.578L956.238 400.361C959.73 402.4 960 399.258 960 395.21L960 373.812C960 369.764 956.402 348.307 952.911 346.273Z",
    fill: "#BFBFBF",
    fillRule: "evenodd",
    fillOpacity: 0.0784314
  }), /*#__PURE__*/React.createElement("path", {
    d: "M897.354 313.881C893.855 311.843 891 313.464 891 317.482L891 335.19C891 339.209 893.835 363.988 897.334 366.012L955.808 399.337C959.307 401.356 960 398.483 960 394.484L960 376.756C960 372.738 956.525 348.061 953.026 346.037Z",
    fill: "#BFBFBF",
    fillRule: "evenodd",
    fillOpacity: 0.0784314
  }), /*#__PURE__*/React.createElement("path", {
    d: "M897.234 313.875C893.776 311.843 891 313.47 891 317.513L891 331.723C891 335.767 893.8 364.027 897.234 366.058L954.43 399.299C957.888 401.33 959 398.693 959 394.655L959 380.439C959 376.401 955.687 348.21 952.229 346.188Z",
    fill: "#BFBFBF",
    fillRule: "evenodd",
    fillOpacity: 0.0784314
  }), /*#__PURE__*/React.createElement("path", {
    d: "M896.348 313.871C892.832 311.85 890 313.467 890 317.48L890 328.036C890 332.048 892.847 363.498 896.348 365.494L953.927 398.265C957.442 400.286 959 397.915 959 393.893L959 383.352C959 379.334 955.763 347.972 952.247 345.947Z",
    fill: "#BFBFBF",
    fillRule: "evenodd",
    fillOpacity: 0.0784314
  }), /*#__PURE__*/React.createElement("path", {
    d: "M896.37 314.866C892.847 312.856 890 314.465 890 318.451L890 325.38C890 329.366 892.857 363.918 896.37 365.923L953.487 398.228C957.01 400.238 959 398.131 959 394.145L959 387.216C959 383.23 955.883 348.717 952.36 346.712Z",
    fill: "#BFBFBF",
    fillRule: "evenodd",
    fillOpacity: 0.0784314
  }), /*#__PURE__*/React.createElement("path", {
    d: "M896.3 314.866C892.816 312.853 890 314.468 890 318.474L890 321.853C890 325.86 892.821 363.942 896.3 365.96L952.126 398.183C955.606 400.196 958 398.333 958 394.322L958 390.943C958 386.936 955.049 348.874 951.569 346.856Z",
    fill: "#BFBFBF",
    fillRule: "evenodd",
    fillOpacity: 0.0784314
  }), /*#__PURE__*/React.createElement("path", {
    d: "M896.322 314.863C892.831 312.861 890 314.461 890 318.441L890 318.238C890 322.217 892.826 363.382 896.322 365.384L951.678 397.138C955.165 399.14 958 397.535 958 393.555L958 393.763C958 389.784 955.169 348.614 951.678 346.612Z",
    fill: "#BFBFBF",
    fillRule: "evenodd",
    fillOpacity: 0.0784314
  }), /*#__PURE__*/React.createElement("path", {
    d: "M958.568 398.99C958.568 398.932 958.568 355.503 958.568 351.899 958.495 351.301 958.45 350.942 958.45 350.942 958.359 348.271 956.5 347.228 954.227 348.611 951.955 349.994 950.095 353.292 950 356.073L950 396.017C952.405 397.453 960 402.019 960 402L960 401.957C959.118 401.531 958.568 400.521 958.568 398.99Z",
    fill: "#BFBFBF",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M887.097 308.623C886.271 307.827 884.941 307.759 883.44 308.623 880.995 310.018 878.995 313.343 878.892 316.148L878.892 317.794 878.892 317.794C878.892 318.329 878.863 364.405 878.863 364.453 878.863 367.035 877.186 370.12 875 371.742 878.745 373.88 928.244 401.667 934.654 405.33 934.654 405.33 935.671 406.296 936.17 406.402 936.199 406.402 939.05 407.787 940.717 408.584L940.717 409.829C940.717 411.605 941.51 412.725 942.717 412.961L942.717 412.961C942.82 412.961 942.923 412.99 943.03 413L943.382 413C944.029 412.938 944.653 412.732 945.206 412.397 945.929 411.971 946.58 411.435 947.133 410.809 947.855 410.146 948.414 409.329 948.766 408.42 949.374 407.253 949.708 405.966 949.744 404.655 949.744 404.631 949.778 404.172 949.778 403.631 949.778 403.371 949.778 368.247 949.778 356.813 949.778 356.813 949.778 356.779 949.778 356.764L949.778 356.016C949.881 353.212 951.876 349.886 954.325 348.491 955.112 347.974 956.072 347.783 957 347.96Z",
    fill: "#F2F2F2",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M909 340 909 338.687 899 333 899 334.308 909 340Z",
    fill: "#8D97D6",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M898 332.727 884 324 884 325.268 898 334 898 332.727Z",
    fill: "#8D97D6",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M887 350 887 351.187 912 365 912 363.813 887 350Z",
    fill: "#8D97D6",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M902 363.797 887 355 887 356.203 902 365 902 363.797Z",
    fill: "#8D97D6",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M898 358.676 887 352 887 353.324 898 360 898 358.676Z",
    fill: "#8D97D6",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M909 382 909 380.692 899 375 899 376.308 909 382Z",
    fill: "#8D97D6",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M902 374.793 884 364 884 365.207 902 376 902 374.793Z",
    fill: "#8D97D6",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M904 375 904 376.222 914 382 914 380.783 904 375Z",
    fill: "#8D97D6",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M915 383.201 929 391 929 389.799 915 382 915 383.201Z",
    fill: "#8D97D6",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M898 374.732 884 366 884 367.268 898 376 898 374.732Z",
    fill: "#8D97D6",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M910 382.276 919 388 919 386.724 910 381 910 382.276Z",
    fill: "#8D97D6",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M878.386 359.864C874.861 357.859 872 359.463 872 363.448L872 366.159C872 370.145 874.861 374.999 878.386 377.003L940.839 411.493C944.364 413.497 942.516 409.182 942.516 405.197L942.516 402.486C942.516 398.501 938.244 393.866 934.714 391.861Z",
    fill: "#BFBFBF",
    fillRule: "evenodd",
    fillOpacity: 0.101961
  }), /*#__PURE__*/React.createElement("path", {
    d: "M878.325 359.87C874.833 357.849 872 359.47 872 363.487L872 365.961C872 369.984 874.833 374.884 878.325 376.905L939.639 411.467C943.131 413.492 941.717 409.378 941.717 405.361L941.717 402.882C941.717 398.859 937.609 394.162 934.117 392.141Z",
    fill: "#BFBFBF",
    fillRule: "evenodd",
    fillOpacity: 0.101961
  }), /*#__PURE__*/React.createElement("path", {
    d: "M878.352 359.88C874.845 357.838 872 359.471 872 363.532L872 365.76C872 369.816 874.845 374.764 878.352 376.807L939.362 411.44C942.869 413.482 941.868 409.582 941.868 405.521L941.868 403.293C941.868 399.232 937.872 394.474 934.359 392.431Z",
    fill: "#BFBFBF",
    fillRule: "evenodd",
    fillOpacity: 0.101961
  }), /*#__PURE__*/React.createElement("path", {
    d: "M878.379 359.87C874.854 357.849 872 359.469 872 363.486L872 365.42C872 369.437 874.854 374.334 878.379 376.36L939.018 410.422C942.543 412.443 941.965 408.827 941.965 404.809L941.965 402.876C941.965 398.854 938.075 394.121 934.555 392.095Z",
    fill: "#BFBFBF",
    fillRule: "evenodd",
    fillOpacity: 0.101961
  }), /*#__PURE__*/React.createElement("path", {
    d: "M878.308 359.879C874.824 357.837 872 359.474 872 363.528L872 365.223C872 369.282 874.824 374.225 878.308 376.266L937.669 410.389C941.153 412.431 940.999 409.031 940.999 404.972L940.999 403.282C940.999 399.228 937.284 394.427 933.781 392.385Z",
    fill: "#BFBFBF",
    fillRule: "evenodd",
    fillOpacity: 0.101961
  }), /*#__PURE__*/React.createElement("path", {
    d: "M878.321 360.869C874.83 358.85 872 360.468 872 364.487L872 365.891C872 369.911 874.83 374.802 878.321 376.822L937.238 410.368C940.73 412.387 941 409.269 941 405.254L941 403.845C941 399.83 937.402 395.055 933.911 393.035Z",
    fill: "#BFBFBF",
    fillRule: "evenodd",
    fillOpacity: 0.101961
  }), /*#__PURE__*/React.createElement("path", {
    d: "M878.334 360.862C874.835 358.861 872 360.464 872 364.438L872 365.565C872 369.54 874.835 374.387 878.334 376.384L936.808 409.342C940.302 411.344 941 408.502 941 404.543L941 403.415C941 399.441 937.52 394.699 934.026 392.697Z",
    fill: "#BFBFBF",
    fillRule: "evenodd",
    fillOpacity: 0.101961
  }), /*#__PURE__*/React.createElement("path", {
    d: "M878.325 360.869C874.817 358.851 872 360.467 872 364.479L872 365.353C872 369.365 874.842 374.256 878.325 376.275L936.363 409.303C939.871 411.322 941 408.702 941 404.689L941 403.816C941 399.803 937.638 394.994 934.13 392.976Z",
    fill: "#BFBFBF",
    fillRule: "evenodd",
    fillOpacity: 0.101961
  }), /*#__PURE__*/React.createElement("path", {
    d: "M878.348 360.877C874.832 358.841 872 360.47 872 364.526L872 365.13C872 369.187 874.847 374.122 878.348 376.162L935.927 409.26C939.442 411.296 941 408.907 941 404.845L941 404.237C941 400.185 937.763 395.309 934.247 393.268Z",
    fill: "#BFBFBF",
    fillRule: "evenodd",
    fillOpacity: 0.101961
  }), /*#__PURE__*/React.createElement("path", {
    d: "M878.278 360.871C874.806 358.849 872 360.468 872 364.478L872 364.808C872 368.818 874.815 373.707 878.278 375.725L934.567 408.226C938.039 410.243 940 408.124 940 404.114L940 403.784C940 399.769 936.929 394.923 933.456 392.906Z",
    fill: "#BFBFBF",
    fillRule: "evenodd",
    fillOpacity: 0.101961
  }), /*#__PURE__*/React.createElement("path", {
    d: "M878.301 361.861C874.816 359.863 872 361.461 872 365.428L872 365.491C872 369.458 874.821 374.291 878.301 376.289L934.126 408.188C937.606 410.186 940 408.338 940 404.371L940 404.313C940 400.341 937.048 395.527 933.568 393.534Z",
    fill: "#BFBFBF",
    fillRule: "evenodd",
    fillOpacity: 0.101961
  }), /*#__PURE__*/React.createElement("path", {
    d: "M878.322 361.869C874.831 359.853 872 361.464 872 365.477L872 365.268C872 369.276 874.826 374.16 878.322 376.176L933.678 408.131C937.169 410.147 940 408.535 940 404.528L940 404.722C940 400.715 937.174 395.83 933.678 393.814Z",
    fill: "#BFBFBF",
    fillRule: "evenodd",
    fillOpacity: 0.101961
  }), /*#__PURE__*/React.createElement("path", {
    d: "M940.425 409.994C940.425 409.942 940.425 402.484 940.425 398.886 940.345 398.29 940.295 397.932 940.295 397.932 940.195 395.275 938.155 394.23 935.65 395.608 933.145 396.987 931.105 400.275 931 403.047L931 407.036C933.65 408.467 942 413.019 942 413L942 412.947C941.045 412.528 940.425 411.507 940.425 409.994Z",
    fill: "#BFBFBF",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M869.101 355.619C868.274 354.828 866.944 354.761 865.442 355.619 862.997 357.004 860.996 360.307 860.898 363.092 860.898 363.092 860.898 364.386 860.898 364.726L860.898 364.726C860.898 365.258 860.864 374.73 860.864 374.792 860.864 377.357 859.186 380.42 857 382.03 860.747 384.154 910.265 411.75 916.672 415.388 916.672 415.388 917.689 416.347 918.188 416.452 918.218 416.452 921.074 417.823 922.737 418.614L922.737 419.855C922.737 421.619 923.529 422.732 924.737 422.962L924.737 422.962C924.839 422.98 924.942 422.992 925.046 423L925.378 423C926.025 422.939 926.649 422.734 927.203 422.401 927.926 421.978 928.576 421.446 929.13 420.824 929.851 420.165 930.41 419.353 930.763 418.451 931.371 417.292 931.705 416.015 931.742 414.712 931.742 414.688 931.776 414.233 931.776 413.691 931.776 413.437 931.776 414.842 931.776 403.472 931.776 403.472 931.776 403.438 931.776 403.424L931.776 402.685C931.879 399.9 933.874 396.598 936.325 395.212 937.111 394.7 938.072 394.51 939 394.685Z",
    fill: "#F2F2F2",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M922.797 420.286C922.813 419.345 923.004 418.415 923.36 417.543L852.205 377.365 851.55 377C851.207 377.866 851.022 378.785 851.002 379.714 850.961 380.908 851.575 382.031 852.608 382.649L924 423 923.913 422.928C923.224 422.467 922.797 421.559 922.797 420.286Z",
    fill: "#BFBFBF",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M902 332.793 884 322 884 323.207 902 334 902 332.793Z",
    fill: "#560F54",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M884 317 884 318.192 912 334 912 332.808 884 317Z",
    fill: "#560F54",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M898 327.696 884 319 884 320.304 898 329 898 327.696Z",
    fill: "#560F54",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M899 328 899 329.236 926 345 926 343.768 899 328Z",
    fill: "#560F54",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M904 333 904 334.196 917 342 917 340.805 904 333Z",
    fill: "#560F54",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M927 345.244 944 355 944 353.761 927 344 927 345.244Z",
    fill: "#560F54",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M919 343.199 936 353 936 351.801 919 342 919 343.199Z",
    fill: "#560F54",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M910 340.276 919 346 919 344.719 910 339 910 340.276Z",
    fill: "#560F54",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M919 352.241 944 367 944 365.754 919 351 919 352.241Z",
    fill: "#560F54",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M919 357.246 944 372 944 370.754 919 356 919 357.246Z",
    fill: "#560F54",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M919 362.246 944 377 944 375.759 919 361 919 362.246Z",
    fill: "#560F54",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M918 351.173C918 351.913 917.329 352.213 916.503 351.839 915.615 351.394 915.056 350.644 915 349.823 915 349.084 915.671 348.788 916.503 349.162 917.386 349.608 917.942 350.355 918 351.173Z",
    fill: "#560F54",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M918 356.176C918 356.915 917.329 357.21 916.503 356.841 915.618 356.394 915.059 355.646 915 354.826 915 354.087 915.671 353.787 916.503 354.161 917.387 354.608 917.943 355.357 918 356.176Z",
    fill: "#560F54",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M918 361.176C918 361.915 917.329 362.21 916.503 361.841 915.618 361.394 915.059 360.646 915 359.826 915 359.087 915.671 358.787 916.503 359.161 917.385 359.61 917.94 360.357 918 361.176Z",
    fill: "#560F54",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M909 371 909 369.692 899 364 899 365.308 909 371Z",
    fill: "#560F54",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M899 359 899 360.232 926 376 926 374.768 899 359Z",
    fill: "#560F54",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M904 364 904 365.196 917 373 917 371.805 904 364Z",
    fill: "#560F54",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M927 376.359 936 382 936 380.641 927 375 927 376.359Z",
    fill: "#560F54",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M919 374.241 944 389 944 387.754 919 373 919 374.241Z",
    fill: "#560F54",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M898 363.721 887 357 887 358.279 898 365 898 363.721Z",
    fill: "#560F54",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M910 371.276 919 377 919 375.724 910 370 910 371.276Z",
    fill: "#560F54",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M884 359 884 360.192 912 376 912 374.808 884 359Z",
    fill: "#560F54",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M894 366.828 884 361 884 362.172 894 368 894 366.828Z",
    fill: "#560F54",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M895 368 895 369.226 926 387 926 385.769 895 368Z",
    fill: "#560F54",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M927 387.239 944 397 944 395.756 927 386 927 387.239Z",
    fill: "#560F54",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M910 393.173 924 401 924 399.827 910 392 910 393.173Z",
    fill: "#560F54",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M924 404 924 402.733 896 386 896 387.262 924 404Z",
    fill: "#560F54",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M905 388.207 924 399 924 397.793 905 387 905 388.207Z",
    fill: "#560F54",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M901 398.793 882 388 882 389.207 901 400 901 398.793Z",
    fill: "#560F54",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M896 392.822 882 385 882 386.173 896 394 896 392.822Z",
    fill: "#560F54",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M909 392 909 390.841 882 376 882 377.159 909 392Z",
    fill: "#560F54",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M904 387 904 385.804 890 378 890 379.196 904 387Z",
    fill: "#560F54",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M877.814 374.752C877.575 373.903 877.086 373.149 876.413 372.592L876.121 373.087C876.685 373.563 877.104 374.194 877.327 374.905 877.553 375.999 877.517 377.132 877.22 378.209 876.879 377.573 876.728 376.85 876.787 376.128 876.913 375.9 876.956 375.633 876.909 375.376 876.888 375.248 876.783 375.153 876.656 375.148 876.526 375.126 876.403 375.215 876.379 375.346 876.321 375.544 876.281 375.746 876.257 375.95 875.96 376.321 875.603 376.638 875.201 376.886L874.802 377.188C874.239 377.621 873.773 378.171 873.436 378.803 873.212 378.526 872.993 378.258 872.779 378.005 872.331 377.476 871.864 376.951 871.402 376.426 870.429 375.326 869.457 374.207 868.6 373.048 868.51 372.477 868.383 371.878 868.221 371.25 868.099 370.755 867.735 369.348 866.338 369.006 866.242 368.985 866.142 369.017 866.076 369.091 866.007 369.162 865.983 369.267 866.013 369.363 866.488 370.773 867.188 372.093 868.085 373.271 868.286 374.469 868.269 375.694 868.036 376.886 867.794 378.015 867.294 379.071 866.577 379.967L866.878 380.462C867.717 379.467 868.301 378.276 868.576 376.995 868.77 376.058 868.828 375.097 868.746 374.142 869.461 375.059 870.245 375.94 871.013 376.817 871.5 377.337 871.937 377.862 872.38 378.387 872.648 378.699 872.925 379.036 873.202 379.377 872.89 380.215 872.78 381.117 872.881 382.007 873.066 383.711 873.854 385.296 874.637 386.831 874.882 387.484 875.471 387.938 876.155 388L876.34 388C876.449 387.981 876.538 387.897 876.563 387.787 877.308 384.682 875.591 381.631 873.83 379.303 874.132 378.649 874.584 378.079 875.148 377.639L875.532 377.352C875.766 377.178 876.019 376.995 876.228 376.802 876.301 377.637 876.606 378.435 877.108 379.1 877.174 379.185 877.281 379.225 877.385 379.204 877.489 379.182 877.57 379.101 877.595 378.996 877.882 377.664 878.217 376.183 877.814 374.752ZM866.732 369.799C867.245 370.194 867.592 370.77 867.705 371.413 867.749 371.582 867.793 371.75 867.832 371.909 867.401 371.238 867.038 370.524 866.747 369.779ZM876.053 387.45C875.566 387.401 875.26 386.905 875.104 386.589 874.35 385.103 873.577 383.557 873.402 381.958 873.323 381.271 873.383 380.575 873.577 379.912 875.172 382.027 876.612 384.726 876.067 387.43Z",
    fill: "#560F54",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M881.021 321.197C879.352 320.225 878 323.068 878 324.997L878 349.413C878.118 351.552 879.241 353.505 881.021 354.67L909.315 370.603C910.979 371.574 913 370.69 913 368.756L913 342.294C913 340.351 910.979 338.116 909.315 337.144Z",
    fill: "#BFBFBF",
    fillRule: "evenodd",
    fillOpacity: 0.0509804
  }), /*#__PURE__*/React.createElement("path", {
    d: "M881.026 321.209C879.356 320.231 878 322.901 878 324.842L878 349.295C878.12 351.445 879.244 353.408 881.026 354.582L909.365 370.598C911.035 371.576 913 370.696 913 368.754L913 342.438C913 340.482 911.035 338.223 909.365 337.25Z",
    fill: "#BFBFBF",
    fillRule: "evenodd",
    fillOpacity: 0.0509804
  }), /*#__PURE__*/React.createElement("path", {
    d: "M881.033 321.217C879.356 320.252 878 322.705 878 324.597L878 348.603C878.118 350.724 879.245 352.661 881.033 353.818L909.42 369.601C911.096 370.567 913 369.707 913 367.791L913 342.129C913 340.197 911.096 337.967 909.42 337.006Z",
    fill: "#BFBFBF",
    fillRule: "evenodd",
    fillOpacity: 0.0509804
  }), /*#__PURE__*/React.createElement("path", {
    d: "M881.038 321.232C879.361 320.26 878 322.539 878 324.464L878 348.506C878.122 350.633 879.25 352.576 881.038 353.736L909.471 369.597C911.148 370.569 913 369.713 913 367.788L913 342.26C913 340.315 911.148 338.065 909.471 337.097Z",
    fill: "#BFBFBF",
    fillRule: "evenodd",
    fillOpacity: 0.0509804
  }), /*#__PURE__*/React.createElement("path", {
    d: "M881.043 321.248C879.365 320.269 878 322.378 878 324.311L878 348.381C878.12 350.523 879.25 352.481 881.043 353.651L909.523 369.593C911.205 370.571 913 369.715 913 367.782L913 342.391C913 340.434 911.205 338.164 909.523 337.19Z",
    fill: "#BFBFBF",
    fillRule: "evenodd",
    fillOpacity: 0.0509804
  }), /*#__PURE__*/React.createElement("path", {
    d: "M881.053 321.266C879.365 320.28 878 322.212 878 324.158L878 348.267C878.119 350.423 879.253 352.391 881.053 353.564L909.575 369.587C911.263 370.573 913 369.725 913 367.774L913 342.532C913 340.561 911.263 338.27 909.575 337.289Z",
    fill: "#BFBFBF",
    fillRule: "evenodd",
    fillOpacity: 0.0509804
  }), /*#__PURE__*/React.createElement("path", {
    d: "M880.972 322.275C879.331 321.323 878 323.003 878 324.878L878 348.038C878.117 350.118 879.221 352.019 880.972 353.155L908.728 368.599C910.369 369.551 912 368.742 912 366.862L912 342.741C912 340.866 910.369 338.624 908.728 337.677Z",
    fill: "#BFBFBF",
    fillRule: "evenodd",
    fillOpacity: 0.0509804
  }), /*#__PURE__*/React.createElement("path", {
    d: "M880.977 322.297C879.331 321.339 878 322.844 878 324.737L878 347.928C878.117 350.02 879.223 351.93 880.977 353.071L908.783 368.594C910.425 369.553 912 368.748 912 366.859L912 342.925C912 341.037 910.425 338.774 908.783 337.821Z",
    fill: "#BFBFBF",
    fillRule: "evenodd",
    fillOpacity: 0.0509804
  }), /*#__PURE__*/React.createElement("path", {
    d: "M880.982 322.323C879.335 321.357 878 322.689 878 324.591L878 347.824C878.122 349.922 879.229 351.836 880.982 352.98L908.835 368.59C910.482 369.556 912 368.75 912 366.853L912 343.074C912 341.172 910.482 338.884 908.835 337.929Z",
    fill: "#BFBFBF",
    fillRule: "evenodd",
    fillOpacity: 0.0509804
  }), /*#__PURE__*/React.createElement("path", {
    d: "M880.988 322.352C879.34 321.38 878 322.532 878 324.446L878 347.702C878.119 349.815 879.228 351.746 880.988 352.901L908.891 368.586C910.54 369.558 912 368.756 912 366.846L912 343.217C912 341.302 910.554 338.994 908.891 338.032Z",
    fill: "#BFBFBF",
    fillRule: "evenodd",
    fillOpacity: 0.0509804
  }), /*#__PURE__*/React.createElement("path", {
    d: "M880.999 322.385C879.345 321.406 878 322.385 878 324.302L878 347.591C878.119 349.717 879.233 351.658 880.999 352.816L908.943 368.58C910.597 369.558 912 368.766 912 366.843L912 343.359C912 341.441 910.597 339.107 908.943 338.143Z",
    fill: "#BFBFBF",
    fillRule: "evenodd",
    fillOpacity: 0.0509804
  }), /*#__PURE__*/React.createElement("path", {
    d: "M881.004 322.415C879.349 321.451 878 322.227 878 324.117L878 346.933C878.121 349.025 879.236 350.937 881.004 352.081L908.996 367.584C910.656 368.548 912 367.777 912 365.887L912 343.062C911.883 340.969 910.766 339.058 908.996 337.918Z",
    fill: "#BFBFBF",
    fillRule: "evenodd",
    fillOpacity: 0.0509804
  }), /*#__PURE__*/React.createElement("path", {
    d: "M909.113 367.66 873.887 348.442C872.294 347.54 871 345.127 871 343.052L871 321.467C871 319.392 872.294 318.438 873.887 319.34L909.113 338.558C910.71 339.46 912 341.869 912 343.948L912 365.528C912 367.608 910.71 368.562 909.113 367.66Z",
    fill: "#26A1AA",
    fillRule: "evenodd",
    fillOpacity: 0.901961
  }), /*#__PURE__*/React.createElement("path", {
    d: "M909.168 338.533 874.625 319.336C873.437 318.655 872.417 319.045 872 320.188 872.479 319.236 873.437 318.959 874.515 319.593L909.062 338.785C910.624 339.686 911.893 342.091 911.893 344.168L911.893 365.719C911.9 366.154 911.83 366.588 911.687 367 911.906 366.519 912.013 365.994 911.999 365.466L911.999 343.916C911.999 341.839 910.734 339.433 909.168 338.533Z",
    fill: "#FFFFFF",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M892.265 352.346 901.536 357.867 901.536 356.339 892.265 350.819ZM896.286 351.298 908 358 908 356.473 896.286 349.756ZM891.197 350.186 885 346.524 885 348.046 891.197 351.733ZM895.213 349.138 885.015 343 885.015 344.527 895.213 350.666Z",
    fill: "#FFFFFF",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M883 341.24 876 337 876 345 883 349Z",
    fill: "#FFFFFF",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M883 348.315 876.31 344.49 876.31 337.185 876 337 876 345 882.99 349Z",
    fill: "#AFB6E5",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M892.275 339.055 899 343 899 341.52 892.275 337.575ZM891.205 336.986 885 333.433 885 334.913 891.205 338.466ZM896.919 336.943 885 330 885 331.48 896.919 338.422Z",
    fill: "#FFFFFF",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M883 328.235 876 324 876 332 883 336Z",
    fill: "#FFFFFF",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M883 335.315 876.31 331.475 876.31 324.18 876 324 876 332 882.99 336Z",
    fill: "#AFB6E5",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M877.051 329.205 878.767 333 881.947 329.598C882.06 329.478 881.983 329.174 881.798 329.007L880.822 328.101C880.694 327.981 880.555 327.965 880.493 328.07L878.767 331.037 878.017 329.211C877.965 329.054 877.843 328.932 877.688 328.881L877.175 328.781C877.015 328.745 876.943 328.959 877.051 329.205Z",
    fill: "#560F54",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M906.492 299.43 909.478 300.276 906.138 308.271 906.102 308.26 906.302 305.007 903.254 307.182Z",
    fill: "#560F54",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.23787 0 5.06814 0 3.79139 11.0197 3.74442 11.0197 2.88794 6.94025 0 10.6841Z",
    fill: "#560F54",
    fillRule: "evenodd",
    transform: "matrix(-0.992987 -0.118227 -0.118227 0.992987 913.042 300.938)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M903.194 297.632 903.292 295.288 902.197 292.777 903.649 291.449 903.977 289.213 906.229 289.408 907.856 288.301 910.047 289.945 912.351 290.39 913.645 292.855 915.745 294.682 915.648 297.026 916.743 299.537 915.291 300.865 914.963 303.101 912.71 302.906 911.084 304.013 908.892 302.369 906.589 301.924 905.295 299.459Z",
    fill: "#26A1AA",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M906.085 298.465C904.281 295.352 904.377 291.925 906.3 290.809 908.224 289.694 911.246 291.314 913.051 294.427 914.856 297.54 914.76 300.967 912.836 302.082 910.913 303.198 907.89 301.578 906.085 298.465Z",
    fill: "#2EC1CC",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M907.289 296.676 908.329 295.92 909.259 297.2 912.365 294.942 912.83 295.581 908.684 298.595Z",
    fill: "#560F54",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M798 559 941 559 941 572 798 572Z",
    fill: "#212121",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M957 560 789.259 560C788.885 556.144 788.915 552.259 789.354 548.409 789.924 544.457 791.253 541.018 794.271 541.018L807.808 541.018 824.307 528.8C827.558 526.361 831.503 525.029 835.566 525L877.639 525C881.208 525.008 884.701 526.022 887.72 527.926L912.402 543.127C912.402 543.127 934.464 545.673 945.836 549.131 948.079 549.641 950.184 550.633 952.007 552.039 953.493 553.626 954.811 555.365 955.937 557.226 956.406 558.102 956.763 559.034 957 560Z",
    fill: "#4ACCD6",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M956.967 560 956.967 566.01C957.236 568.564 955.821 570.995 953.481 572L938.701 572C936.556 564.221 928.573 559.67 920.872 561.836 915.985 563.21 912.169 567.066 910.809 572L834.218 572C832.325 564.263 824.583 559.54 816.922 561.451 811.771 562.736 807.749 566.798 806.477 572L788.381 572C785.274 567.311 788.381 560 788.381 560Z",
    fill: "#00BAC6",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M833 529 857 529 857 543 833 543Z",
    fill: "#560F54",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M858 529 882 529 882 543 858 543Z",
    fill: "#560F54",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M884 529 884 542.872 902.119 543C902.601 543.004 902.996 542.629 903 542.163 903.002 541.903 902.88 541.657 902.669 541.495Z",
    fill: "#560F54",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M831 529 830.907 543C830.907 543 820.803 542.833 820.524 543 818.867 541.794 818.505 539.476 819.716 537.825 819.941 537.516 820.214 537.244 820.524 537.019 823.756 534.148 831 529 831 529Z",
    fill: "#560F54",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M956 558 949.759 558C947.128 557.99 945 555.818 945 553.143 944.993 551.988 945.4 550.87 946.148 550 948.339 550.488 950.395 551.465 952.167 552.861 953.617 554.434 954.902 556.156 956 558Z",
    fill: "#FFFFFF",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M832 575.922C832.042 582.55 826.706 587.957 820.078 588 813.451 588.043 808.043 582.705 808 576.078 807.958 569.45 813.296 564.043 819.922 564 819.948 564 819.975 564 820 564 826.597 564 831.957 569.325 832 575.922Z",
    fill: "#222C36",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M828 576C828 580.531 824.382 584.216 819.892 584.259L819.892 588 819.892 588C813.324 588 808 582.627 808 576 808 569.373 813.324 564 819.892 564L819.892 564 819.892 567.761C824.379 567.793 828 571.472 828 576Z",
    fill: "#304153",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M828 575.991C828 580.38 824.531 583.949 820.227 583.991L820.227 583.991C815.898 584.205 812.219 580.8 812.009 576.387 811.799 571.974 815.137 568.224 819.466 568.009 819.72 567.997 819.974 567.997 820.227 568.009L820.227 568.009C824.528 568.04 828 571.605 828 575.991Z",
    fill: "#D8E3DB",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M820 568 820 568 820 584 820 584C824.637 583.786 828.215 580.03 827.99 575.612 827.779 571.494 824.324 568.2 820 568Z",
    fill: "#D8E3DB",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M826 575.5C826 579.09 823.313 582 820 582 816.687 582 814 579.09 814 575.5 814 571.91 816.687 569 820 569 823.313 569 826 571.91 826 575.5Z",
    fill: "#212121",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M824 575.99C824.012 578.187 822.173 579.979 819.886 580L819.886 580C817.586 579.847 815.852 577.932 816.01 575.723 816.156 573.727 817.809 572.138 819.886 572L819.886 572C822.165 572.021 824 573.801 824 575.99Z",
    fill: "#D8E3DB",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M820 572 820 572 820 580 820 580C822.368 579.847 824.152 577.932 823.99 575.723 823.84 573.727 822.138 572.138 820 572Z",
    fill: "#D8E3DB",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M937 575.922C937.042 582.55 931.706 587.957 925.078 588 918.452 588.043 913.043 582.705 913 576.078 912.958 569.45 918.297 564.043 924.923 564 924.948 564 924.975 564 925 564 931.597 564 936.957 569.325 937 575.922Z",
    fill: "#222C36",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M933 576C933 580.539 929.374 584.227 924.881 584.259L924.881 588 924.881 588C918.319 588 913 582.627 913 576 913 569.373 918.319 564 924.881 564L924.881 564 924.881 567.761C929.367 567.793 932.99 571.469 933 576Z",
    fill: "#304153",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M933 575.991C933 580.387 929.307 583.959 924.731 583.991L924.731 583.991C920.137 584.205 916.233 580.8 916.01 576.387 915.787 571.974 919.329 568.224 923.923 568.009 924.193 567.997 924.463 567.997 924.731 568.009L924.731 568.009C929.299 568.04 932.99 571.602 933 575.991Z",
    fill: "#D8E3DB",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M925 568 925 568 925 584 925 584C929.637 583.786 933.215 580.03 932.99 575.612 932.779 571.494 929.324 568.2 925 568Z",
    fill: "#D8E3DB",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M931 575.5C931 579.09 928.313 582 925 582 921.687 582 919 579.09 919 575.5 919 571.91 921.687 569 925 569 928.313 569 931 571.91 931 575.5Z",
    fill: "#212121",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M929 575.99C929.012 578.187 927.173 579.979 924.886 580L924.886 580C922.586 579.847 920.852 577.932 921.01 575.723 921.156 573.727 922.809 572.138 924.886 572L924.886 572C927.165 572.021 929 573.801 929 575.99Z",
    fill: "#D8E3DB",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M925 572 925 572 925 580 925 580C927.368 579.847 929.152 577.932 928.99 575.723 928.84 573.727 927.138 572.138 925 572Z",
    fill: "#D8E3DB",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M798 543.653C798 546.606 795.536 549 792.497 549 792.49 549 792.482 549 792.476 549L790.407 549C789.931 549.002 789.459 548.941 789 548.819 789.621 544.638 791.069 541 794.359 541L797.255 541C797.735 541.807 797.992 542.721 798 543.653Z",
    fill: "#FFFFFF",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M839.733 549 835.287 549C834.577 549 834 548.323 834 547.488L834 547.488C834.01 546.662 834.583 546 835.287 546L839.733 546C840.433 546 841 546.666 841 547.488L841 547.488C841 548.314 840.437 548.987 839.733 549Z",
    fill: "#FFFFFF",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M863.713 549 859.267 549C858.563 548.987 858 548.314 858 547.488L858 547.488C858 546.666 858.567 546 859.267 546L863.713 546C864.417 546 864.99 546.662 865 547.488L865 547.488C865 548.323 864.423 549 863.713 549Z",
    fill: "#FFFFFF",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M857.866 561 832 561 832 527 858 527 858 527.155C858 536.252 857.731 560.011 858 560.787L857.866 560.787ZM832.307 560.69 857.693 560.69C857.424 558.246 857.578 539.064 857.693 527.271L832.307 527.271Z",
    fill: "#00BAC6",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M877.028 561 870 561 857.154 561 857 561 857 527 881.195 527C882.17 526.979 882.979 527.759 883 528.742 883 528.755 883 528.768 883 528.781 882.846 543.565 882.789 559.587 883 560.671L883 560.671 883 560.787C882.981 560.942 882.962 561 877.028 561ZM857.307 560.613C865.679 560.613 881.137 560.729 882.693 560.613 882.578 559.607 882.443 554.614 882.693 528.742 882.697 528.347 882.537 527.968 882.251 527.697 881.975 527.408 881.592 527.247 881.195 527.252L857.307 527.252Z",
    fill: "#00BAC6",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M801.139 553 789 553 789 552.678 801.101 552.678C803.095 552.667 804.844 551.278 805.408 549.261L807.695 541 808 541 805.713 549.281C805.128 551.446 803.272 552.954 801.139 553Z",
    fill: "#00BAC6",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M944.942 552 918.619 548.895 918.6 548.877 912 544.237 912.194 544 918.735 548.621 945 551.726 944.942 552Z",
    fill: "#00BAC6",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip24)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip25)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip26)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M132.836 0 13.4442 73.9881C0.120878 82.2125-4.01258 99.6804 4.21184 113.004 4.21546 113.01 4.21911 113.015 4.22274 113.021L44.3207 177.987 132.836 177.987Z",
    fill: "#560F54",
    transform: "matrix(1 0 0 1.00038 1052.08 547)"
  })))), /*#__PURE__*/React.createElement("path", {
    d: "M1074 113.38C1074.06 104.919 1080.68 97.9026 1088.01 93.8533 1095.35 89.8042 1103.65 87.8098 1111.1 84.0082 1118.55 80.2068 1125.5 73.6435 1126.31 65.273 1127.29 54.9988 1118.84 45.3654 1120.56 35.1939 1122.19 25.5603 1132.03 19.8914 1141.05 16.3135 1154.57 10.954 1168.66 7.20171 1183.04 5.13286L1184 4.99989 1184 156C1182.32 154.731 1180.55 153.58 1178.72 152.555 1165.71 145.303 1150.39 143.737 1135.59 142.704 1120.79 141.671 1105.55 140.891 1091.9 134.962 1082.84 131.01 1073.93 123.316 1074 113.38Z",
    fill: "#560F54",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip28)",
    transform: "matrix(1 -1.22465e-16 -1.22465e-16 -1 99 723)"
  }, /*#__PURE__*/React.createElement("use", {
    width: "100%",
    height: "100%",
    xlinkHref: "#img27",
    transform: "scale(1 1)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFondo2);
export default __webpack_public_path__ + "static/media/fondo2.76a98109e8d70974c9dff06eebd42f44.svg";
export { ForwardRef as ReactComponent };